import store from '@/desktop/stores'

export const queryUser = function(id, pwd) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            conditions: {
                id: id,
                pwd: pwd
            }
        }
    }
    return body
}

export const queryUserSSO = function() {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            serNo: new Date().getTime()
        }
    }
    return body
}

export const queryNews = function(userId, div_no, dept_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            div_no: div_no,
            mkt_dept_no: dept_no
        }
    }
    return body
}

export const queryVideos = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            showRecords: "4"
        }
    }
    return body
}

export const getRecentDynamic = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId
        }
    }
    return body
}

export const getFamilys = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                api_id: 'queryJoinList'
            }
        }
    }
    return body
}

export const getFamilInsertList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                api_id: 'queryInsertList'
            }
        }
    }
    return body
}

export const addFamilyMembers = function(userId, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Type: "insert",
                Agent: userId,
                Value: insertData,
            }
        }
    }
    return body
}

export const deleteFamilyMembers = function(userId, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Type: "delete",
                Agent: userId,
                Value: insertData,
            }
        }
    }
    return body
}

export const updateFamilyMembers = function(userId, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Type: "update",
                Agent: userId,
                Value: insertData,
            }
        }
    }
    return body
}

export const queryFamilyMem = function(userId, custId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                csid: custId ? custId : serNo
            }
        }
    }
    return body
}

export const queryCustInsurance = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                csid: custId,
                agid: userId
            }
        }
    }
    return body
}

export const queryInsuPayRecords = function(userId, policyNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                POLICY_NO: policyNo
                    // POLICY_NO: '7212117115'
            }
        }
    }
    return body
}


//查詢是否為產險客戶(包含客戶Info資料)
export const isPropertyCustomer = function(userId, custId, isFromPropertyCust = false) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            id: custId,
            isFromPropertyCust: isFromPropertyCust
        }
    }
    return body
}


export const queryCustInsuranceGroupAndAccident = function(userId, csid, nationCode) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGNT_ID: userId,
            ID: csid,
            NATION_CODE: nationCode
        }
    }
    return body
}

export const queryCustPropertyInsurance = function(userId, csid, isFromMV = true, isFromPropertyCustomer = false) {
    if (csid && !Array.isArray(csid)) {
        csid = [csid]
    }
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                csid: csid,
                isFromMV,
                isFromPropertyCustomer
            }
        }
    }
    return body
}

export const queryFireDetail = function(userId, ceplcno, isFromPropertyCustomer = false) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                ceplcno: ceplcno,
                isFromPropertyCustomer
            }
        }
    }
    return body
}

export const queryCarsDetail = function(userId, ceplcno, isFromPropertyCustomer = false) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                ceplcno: ceplcno, 
                isFromPropertyCustomer
            }
        }
    }
    return body
}

export const queryCustOtherInsurance = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AgentID: userId,
            MemberId: csid,
        }
    }
    return body
}

export const queryCustOtherPropertyInsurance = function(userId, csid, insurancetype) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                csid: csid,
                insurancetype: insurancetype
            }
        }
    }
    return body
}

//取得該cust詳細資訊
export const queryCustInfo = function(userId, agnt_id, csid, api_id, curr) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id, // 1:取客戶個人資訊,財務狀況,行銷方式  2:取客戶服務申辦項目
            customer: {
                agnt_id: agnt_id,
                id: csid,
                curr: curr
            }
        }
    }
    return body
}

// 新增客戶個人頁面點擊log紀錄
export const addCustInfoLog = function(userId, logData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            logData: logData
        }
    };
    return body;
}

// 查詢客戶個人頁面點擊log紀錄
export const queryCustInfoLog = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId
        }
    };
    return body;
}

// 查詢近期搜尋客戶
export const queryRecentCust = function(userId, orderBy, order, act_type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId,
            order_by: orderBy,
            order: order,
            act_type: act_type
        }
    };
    return body;
}

//取得客戶名單專區資料
export const queryCustCategory = function(userId, agnt_id, csid, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id, // 5:取得客戶名單專區資料
            customer: {
                agnt_id: agnt_id,
                id: csid
            }
        }
    }
    return body
}

//取得拒絕國泰人壽行銷
export const queryRejectCathayMarketing = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                csid: csid,
            }
        }
    }
    return body
}

//取得投資風險屬性
export const queryRiskAttributes = function(csid, nationCode, birthday) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: {
            apc_id: csid,
            nation_code: nationCode,
            birthday: birthday
        }
    }
    return body
}

export const getCustDie = function(userId, csid, ) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                id: csid,
            }
        }
    }
    return body
}

export const queryCustomers = function(input, s1 = '1', s2 = '1', s3 = '1', s4 = '1', s5 = '1', s6 = 'N', page = '1', order_by = '2', order_asc = '1', rows = '999999') {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            conditions: {
                input: input ? input : '',
                cs_source1: s1,
                cs_source2: s2,
                cs_source3: s3,
                cs_source4: s4,
                cs_source5: s5,
                cs_source6: s6,
                page: page,
                rows: rows,
                order_by: order_by,
                order_asc: order_asc,
            }
        }
    }
    return body
}

export const queryGroup = function(userId, grpid, csid, agnt_id, keyword, api, filterCondition) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api,
            filterCondition: filterCondition,
            report: {
                grpid: grpid,
                csid: csid,
                agnt_id: agnt_id,
                searchword: keyword
            }
        }
    }
    return body
}

/*
 * addNewGroup @parameter agnt_id,grp_name,members
 * updateOldGroup @parameter agnt_id,grp_id,grp_name,members
 */
export const updateGroup = function(agnt_id, grp_id, grp_name, members, api) {
    let memFormatedArr = []
    members.forEach((mem) => {
        let eachRecord = {
            agnt_id: agnt_id,
            id: mem.identity,
            grpid: grp_id,
            grp_name: grp_name
        }
        memFormatedArr.push(eachRecord)
    })
    const body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agnt_id
        },
        body: {
            api_id: api,
            report: {
                agnt_id: agnt_id,
                grpid: grp_id,
                grp_name: grp_name,
                recordsList: memFormatedArr
            }
        }
    }
    return body
}

export const updateGrpMem = function(agnt_id, grp_id, grp_name, members, api) {
    let memFormatedArr = []
    members.forEach((memId) => {
        let eachRecord = {
            agnt_id: agnt_id,
            id: memId,
            grpid: grp_id,
            grp_name: grp_name
        }
        memFormatedArr.push(eachRecord)
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agnt_id
        },
        body: {
            api_id: api,
            report: {
                agnt_id: agnt_id,
                grpid: grp_id,
                grp_name: grp_name,
                recordsList: memFormatedArr
            }
        }
    }

    return body
}

export const removeGrp = function(userId, agnt_id, grp_id, api) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api,
            report: {
                agnt_id: agnt_id,
                grpid: grp_id
            }
        }
    }
    return body
}

export const updateGroupsByCust = function(userId, agnt_id, csid, groups) {
    let groupsData = groups.map(item => {
        return {
            agnt_id: agnt_id,
            csid: csid,
            grpid: item.grp_id,
            grp_name: item.grp_name
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "C14",
            report: {
                agnt_id: agnt_id,
                csid: csid,
                recordsList: groupsData
            }
        }
    }
    return body
}

export const createGroupsByCust = function(userId, agnt_id, csid, source, groups) {
    let groupsData = groups.map(item => {
        return {
            grp_name: item.grp_name
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "C15",
            report: {
                agnt_id: agnt_id,
                csid: csid,
                source: source,
                groupList: groupsData
            }
        }
    }
    return body
}

export const getServiceRecordBody = function(userId, csid) {
    let body = {
        body: {
            report: {
                agnt_id: userId,
                cust_id: csid
            }
        },
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },

    }
    return body
}

//查詢保單無記名家庭關係
export const queryFamilyRelationOfInsurance = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "query",
            report: {
                csid: custId,
                agidno: userId
            }
        }
    }
    return body
}

//新增保單無記名家庭關係
export const addFamilyRelationOfInsurance = function(userId, custId, cop_id, name, birthday, kind) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "add",
            report: {
                csid: custId,
                agidno: userId,
                cop_id: cop_id,
                cop_name: name,
                cop_birthday: birthday,
                cop_kind: kind
            }
        }
    }
    return body
}

//更新保單無記名家庭關係
export const updateFamilyRelationOfInsurance = function(userId, custId, cop_id, name, birthday, kind) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "update",
            report: {
                csid: custId,
                agidno: userId,
                cop_id: cop_id,
                cop_name: name,
                cop_birthday: birthday,
                cop_kind: kind
            }
        }
    }
    return body
}

//刪除保單無記名家庭關係
export const deleteFamilyRelationOfInsurance = function(userId, custId, cop_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "delete",
            report: {
                csid: custId,
                agidno: userId,
                cop_id: cop_id,
            }
        }
    }
    return body
}

//查詢筆記簿
export const getQueryNoteList = function(userId, custId, is_done, rocyear) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "query",
            conditions: {
                csid: custId,
                agid: userId,
                is_done: is_done,
                rocyear: rocyear,
            }
        }
    }
    return body
}
//查詢BOX紀錄
export const queryBoxRecord = function(userId, agId, custId, is_done, rocyear) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "query",
            conditions: {
                csid: custId,
                agid: agId,
                is_done: is_done,
                rocyear: rocyear,
            }
        }
    }
    return body
}


//增值回饋分享金_保單主約資料查詢
export const valueAdded_queryPolicyInfo = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                POLICY_NO: policy_no,
                QRY_ID: userId
            }
        }
    }
    return body
}

//取得繳清保額繳清始期等相關資訊(CRM使用)
export const queryPaupInfo = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                POLICY_NO: policy_no,
            }
        }
    }
    return body
}


/*
 * Required @parameter api_id,userId,csid
 *
 * insertNewNote @parameter NOTE_STRING
 * updateNote @parameter NOTE_DATE,NOTE_TIME,NOTE_STRING
 * queryNote @parameter DEVICE,CLIENT_IP
 */
export const personalNote = function(api_id, userId, csid, noteContent = null, uDate = null, uTime = null) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id,
            note: {
                AGIDNO: userId,
                CSIDNO: csid,
                NOTE_DATE: uDate,
                NOTE_TIME: uTime,
                NOTE_STRING: noteContent,
                DEVICE: "desktop",
                CLIENT_IP: store.state.userIP,
                SOURCE: "CRM"
            }
        }
    }
    return body
}

export const getCustIAA = function(userId, csid, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id,
            report: {
                csid: csid
            }
        }
    }
    return body
}

export const queryIAA_Request = function(userId, csid, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id,
            report: {
                csid: csid
            }
        }
    }
    return body
}

export const ReportIAA_Request = function(userId, csid, check, check_item, api_id) {

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id,
            report: {
                csid: csid,
                check: check,
                check_item: {
                    tel: check_item.tel,
                    mobile1: check_item.mobile1,
                    mobile2: check_item.mobile2,
                    addr: check_item.addr,
                    email: check_item.email
                }
            }
        }
    }
    return body
}

export const housingLoans = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: userId
            userId: userId
        },
        body: {
            conditions: {
                // BORROW_ID: 'A18833614G',
                // USER_ID: 'A16096882I'
                BORROW_ID: csid,
                USER_ID: userId
            }
        }
    }
    return body
}

export const printPDF = function(userId, csidAry, api_id, isAll, keyword, s1, s2, s3, s4, s5, s6, order_by, order_asc, page, rows, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            category: api_id,
            report: {
                customers: {
                    csid: csidAry
                },
                isAll: isAll,
                conditions: {
                    input: keyword ? keyword : '',
                    cs_source1: s1,
                    cs_source2: s2,
                    cs_source3: s3,
                    cs_source4: s4,
                    cs_source5: s5,
                    cs_source6: s6,
                    page: page,
                    rows: rows,
                    order_by: order_by,
                    order_asc: order_asc,
                    type: type,
                }
            }
        }
    }
    return body
}

export const printInvPDF = function(userId, reqObj) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqObj
    }
    return body
}

export const savePrintAddress = function(userId, selectAddress, selectCompanyAddress, isAddress, isCompanyAddress) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                selectAddress: selectAddress,
                selectCompanyAddress: selectCompanyAddress,
                isAddress: isAddress,
                isCompanyAddress: isCompanyAddress
            }
        }
    }
    return body
}

export const getCustDataForSavePrint = function(userId, custids) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            custIDList: custids
        }
    }
    return body
}

export const minorInsurDetail = function(userId, policyNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                POLICY_NO: policyNo
                    // POLICY_NO: '7212717961'
            }
        }
    }
    return body
}

export const queryDistByCity = function(userId, city) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: 'query',
            city: city
        }
    }
    return body
}

export const getJobs = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: '1'
        }
    }
    return body
}

export const getJobsByJobName = function(userId, jobName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            JOB_NAME: jobName
        }
    }
    return body
}

export const AddLatAndLnt = function(userId, csId, address, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            address: address,
            type: type,
            csId: csId,
            agId: userId
        }
    }
    return body
}

export const insertNewCust = function(userId, data, trn_cd) {
    let isAllExist = new Set(data.birthday.map(num => { return num.toString().trim() != '' }))
    let body = {
            header: {
                userDeviceIp: store.state.userIP,
                userId: userId
            },
            body: {
                api_id: 'add',
                customer: {
                    name: data.name,
                    id: data.identityID,
                    birthday: isAllExist.has(false) ? '' : data.birthday.join('-'),
                    sex: data.gender,
                    wg_name: data.wg_name,
                    age: data.age
                },
                info: {
                    lineid: data.lineid,
                    mobile: data.mobile,
                    home_tel_area: data.phone[0],
                    home_tel: data.phone[1],
                    corp_tel_area: data.office_phone[0],
                    corp_tel: data.office_phone[1],
                    corp_tel_ext: data.office_phone[2]
                },
                data: {
                    email: data.email,
                    introducer: data.introducerId,
                    job: data.career,
                    corp: data.agency,
                    edu: data.education,
                    marry: data.marriage,
                    housing_status: data.housing_status,
                    home_address: {
                        home_addr_zip: data.address[3],
                        home_addr1: data.address[0],
                        home_addr2: data.address[1],
                        home_addr3: data.address[2]
                    },
                    corp_address: {
                        corp_addr_zip: data.office_address[3],
                        corp_addr1: data.office_address[0],
                        corp_addr2: data.office_address[1],
                        corp_addr3: data.office_address[2]
                    },
                    fax_area: data.fax_area,
                    fax: data.fax
                },
                financial: {
                    incomy: data.personal_income,
                    invest: data.monthly_invest,
                    finance: data.finance_tool,
                    car: data.vehicle,
                    family_incom: data.household_income,
                    house: data.housing,
                    loan_amt: data.houseloan
                },
                groups: data.group,
                upd: {
                    upd_id: userId,
                    upd_source: '1'
                },
                memo: data.memo,
                agnt_id: userId,
                trn_cd: trn_cd
            }
        }
        // let customer = {}
        // if(this.strIsNotEmpty(data.name)) { customer['name'] = data.name}
        // if(this.strIsNotEmpty(data.identityID)) { customer['id'] = data.identityID}
        // if(!data.birthday.map(item => this.isNotEmpty(item)).indexOf(false) > -1) { customer['birthday'] = data.birthday.join('')}
        // if(this.strIsNotEmpty(data.gender)) { customer['sex'] = data.gender}
    return body
}

export const queryProgressNewConTract = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGENT_ID: userId,
            CUSTOMER_ID: custId
                // AGENT_ID:"A18721234D",
                // CUSTOMER_ID:"A29677059C"
        }
    }
    return body
}

//查詢主約基本資料
export const queryMainPolicyInfo = function(policy_no, qry_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: qry_id
        },
        body: {
            report: {
                POLICY_NO: policy_no,
                QRY_ID: qry_id
                    // POLICY_NO: "9139221238",
                    // POLICY_NO: "7704199338",
                    // QRY_ID: "P28820964I"
            }
        }
    }
    return body
}

//查詢主約受益人明細
export const queryMainPolicyBeneficiariesInfo = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                POLICY_NO: policy_no
                    // POLICY_NO:"1000192165"
            }
        }
    }
    return body
}

//查詢投資績效
export const queryInvestPerformance = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            POLICY_NO: policy_no
                // POLICY_NO: '9156290936'
        }
    }
    return body
}

export const queryProgressLoan = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            BORROW_ID: custId,
            AGENT_ID: userId
                // BORROW_ID:"E28600048J",
                // AGENT_ID:"E28704135J"
        }
    }
    return body
}

export const editCustFinancial = function(userId, csid, data, custType) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                id: csid,
                financial: {
                    id: csid,
                    incomy: data.personal_income,
                    invest: data.monthly_invest,
                    finance: data.finance_tool,
                    car: data.vehicle,
                    family_incom: data.household_income,
                    house: data.housing,
                    loan_amt: data.houseloan == '' ? '0' : data.houseloan
                },
                custType: custType,
                upd: {
                    upd_id: userId,
                    upd_source: '1' // CRM = 1
                }
            }

        }
    }
    return body
}

/*
 * 編輯客戶個人資訊&基本資料
 * 
 * headerData 為上方的個人資訊(性別 電話 地址 等等)
 * bodyData 為下方的個人資訊(職業 學歷 婚姻 email 等等)
 *
 * 若只更新上方,帶入上方的data,下方帶入null即可
 */
export const editCustInfo = function(userId, csid, headerData, bodyData) {
    let transHeaderData = {}
    let transBodyData = {}

    if (headerData) {
        transHeaderData = {
            name: headerData.name,
            ser_no: headerData.serNo,
            id: headerData.ID,
            familyrl: headerData.familyrl,
            birthday: headerData.birthday,
            sex: headerData.gender,
            mobile: headerData.mobile,
            home_tel_area: headerData.phone[0],
            home_tel: headerData.phone[1],
            corp_tel_area: headerData.office_phone[0],
            corp_tel: headerData.office_phone[1],
            corp_tel_ext: headerData.office_phone[2],
            home_address: {
                home_addr_zip: headerData.address[0],
                home_addr1: headerData.address[1],
                home_addr2: headerData.address[2],
                home_addr3: headerData.address[3],
            },
            corp_address: {
                corp_addr_zip: headerData.office_address[0],
                corp_addr1: headerData.office_address[1],
                corp_addr2: headerData.office_address[2],
                corp_addr3: headerData.office_address[3],
            },
            lineid: headerData.lineid,
            wg_name: headerData.wg_name,
            age: headerData.age
        }
    }
    if (bodyData) {
        transBodyData = {
            email: bodyData.email,
            introducer: bodyData.introducerId,
            // job: bodyData.career,
            std_occupation_cd: bodyData.career_box,
            corp: bodyData.agency,
            edu: bodyData.education,
            marry: bodyData.marriage,
            housing_status: bodyData.housing_status,
            fax_area: bodyData.fax[0],
            fax: bodyData.fax[1],
            ser_no: bodyData.serNo,
        }
    }

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                csid: csid,
                info: transHeaderData,
                data: transBodyData,
                customer: {},
                upd: {
                    upd_id: userId,
                    upd_source: '1'
                }
            }
        }
    }
    return body
}


//新增業務員確認客戶同意蒐集資料LOG
export const insertDataCollectionLog = function(userId, csid, trn_cd) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId,
            csid: csid,
            trn_cd: trn_cd
        }
    }
    return body
}

//新增業務員點擊LOG
export const addActionLog = function(userId, action_item, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId,
            action_item: action_item,
            csid: csid
        }
    }
    return body
}

export const queryPayRecord = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                // AGNT_ID: "C18768708E",
                // ID: "N26733789H"
                AGNT_ID: userId,
                ID: custId
            }
        }
    }
    return body
}

export const queryPremiumRecord = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                APC_ID: custId,
                CLC_ID: userId
            }
        }
    }
    return body
}

export const queryInsuranceClaimRecord = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                // APLY_EMP_ID: "F28976146C",
                // OCR_ID: "F28675049E"
                APLY_EMP_ID: userId,
                OCR_ID: custId
            }
        }
    }
    return body
}

export const queryInvestProfit = function(userId, custId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            // POLICY_NO:"9050605121",
            // INSD_ID:"N18085345E"
            POLICY_NO: policy_no,
            INSD_ID: custId
        }
    }
    return body
}

//查詢所有主附約商品名稱&ID
export const queryPlanCode = function(userId, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                type: type
            }
        }
    }
    return body
}

//查詢繳費訊息
export const queryPaymentMessage = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            POLICY_NO: policy_no
                // POLICY_NO:"7241276575"
        }
    }
    return body
}

//查詢各功能的企劃單位連絡方式
export const getContactInfo = function(function_name) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            function_name: function_name
        }
    }
    return body
}



//以流水編號查詢各功能的企劃單位連絡方式
export const getContactInfoBySerNo = function(userId, ser_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            ser_no: ser_no
        }
    }
    return body
}


//親疏等級-查詢問券資訊
export const getSurveyInfo = function(userId, custId, surveyNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            ser_no: surveyNo,
            agnt_id: userId,
            cust_id: custId
        }
    }
    return body
}

//申辦進度-整合行銷
export const queryIntegratedMarketing = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
                // userId:"A18279058E"
        },
        body: {
            report: {
                csid: custId
                    // csid:"A18279058E"
            }
        }
    }
    return body
}

//條件篩選項目
export const getSearchFilter = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
            // userId:"A28747649C",
        },
        body: {

        }
    }
    return body
}

//取得自訂篩選條件
export const getCustomizeFilter = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
        }
    }
    return body
}

//編輯自訂篩選條件
export const modifyCustomizeFilter = function(userId, filterItem) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            field_name: filterItem,
        }
    }
    return body
}

//查詢客戶by條件篩選
export const queryCustListByCustomized = function(userId, conditionsObj, option_ch) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                option_ch: option_ch,
                conditions: conditionsObj
            }
        }
    }
    return body
}


//查詢產險續保保單清單
export const queryPropertyInsurance = function(userId, conditionsObj, option_ch) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                option_ch: option_ch,
                conditions: conditionsObj
            }
        }
    }
    return body
}

//查詢客戶>>取得查詢紀錄
export const getSearchRecord = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            status: "S",
        }
    }
    return body
}

//查詢客戶>>取得我的最愛
export const getSearchFavorite = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            status: "F",
        },
    }
    return body
}

//查詢客戶>>新增我的最愛
export const insertFavorite = function(userId, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            field_name: insertData.field_name,
            option: insertData.option,
            option_ch: insertData.option_ch,
            favorite_name: insertData.favorite_name,
        }
    }
    return body
}

//查詢客戶>>編輯我的最愛
export const modifyFavorite = function(userId, modifyData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            field_name: modifyData.field_name,
            option: modifyData.option,
            option_ch: modifyData.option_ch,
            favorite_name: modifyData.favorite_name,
            original_favorite_name: modifyData.original_favorite_name,
        }
    }
    return body
}

//查詢客戶>>刪除我的最愛
export const deleteFavorite = function(userId, deleteName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            favorite_name: deleteName,
        }
    }
    return body
}


//刪除客戶
export const deleteCust = function(userId, custId, time, cust_name, csidAry, keyword) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
            requestTimestamp: time
        },
        body: {
            conditions: {
                csid: custId,
                agid: userId,
                name: cust_name,
                csids: csidAry,
                input: keyword ? keyword : '',
            }
        }
    }
    return body
}

//編輯客戶資料更新時間_多筆
export const retainCustomers = function(userId, selection, arg) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                selection: selection,
            }
        }
    }
    return body
}


//業務員確認客戶同意蒐集資料寄送email
export const sendDataCollectionEmail = function(userId, data, mailAttachmentName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            mail_data: data,
            mailAttachmentName: mailAttachmentName
        }      
    }
    return body
}

//增值回饋分享金試算表資料寄送email
export const sendValueAddedBonusIllustrationEmail = function(userId, data, mailAttachmentName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            data: data,
            mailAttachmentName: mailAttachmentName
        }      
    }
    return body
}


//點選訊息
export const selectMessage = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                extend: "1",
            }
        }
    }
    return body
}

//點選訊息-查詢個人資訊
export const selectMsgCustInfo = function(userId, id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                id: id
            }
        }
    }
    return body
}

//查詢新契約變更項目
export const queryh013 = function(userId, id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                csid: id
            }
        }
    }
    return body
}


//點選訊息-更新
export const updCustMsgCust = function(userId, updInfo, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            updInfo,
            agid: userId,
            csid: csid
        }
    }
    return body
}


//判斷是否為投資型商品
export const isInvProd = function(userId, prod_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            PROD_ID: prod_id
        }
    }
    return body
}

//以保單號碼查詢服務件
export const checkInsByNo = function(userId, cedvno3, plcno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                search_by: "1",
                plcno: plcno,
            }
        }
    }
    return body
}

//以ID查詢服務件
export const checkInsById = function(userId, cedvno3, ceapcno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                search_by: "2",
                ceapcno: ceapcno,
            }
        }
    }
    return body
}

// 查詢撥出各類別業務員數與已撥客戶
export const getOutSegment = function(userId, cedvno3, role_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                io: "O",
                role_id: role_id
            }
        }
    }
    return body
}

// 查詢撥入各類別業務員數與已撥客戶
export const getInSegment = function(userId, cedvno3, role_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                io: "I",
                role_id: role_id
            }
        }
    }
    return body
}

// 查詢轄下撥出人員
export const getOutAgnClcNo = function(userId, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                segment: "O",
            }
        }
    }
    return body
}

// 查詢轄下撥入人員
export const getInAgnClcNo = function(userId, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                segment: "I",
            }
        }
    }
    return body
}

// 查詢各類別人員明細
export const getSegmentAgnt = function(userId, cedvno3, segment) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                segment: segment,
            }
        }
    }
    return body
}

// 查詢區部未訪件單位統計層資料
export const getSegmentUnitsData = function(userId, cedvno3, segmentCode, segmentName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                segmentCode: segmentCode,
                segmentName: segmentName
            }
        }
    }
    return body
}

// 取得同業壽險公司別
export const getInsuranceCompanyList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {},
        }
    }
    return body
}

// 取得同業壽險主約險種
export const getInsuraneProduct = function(userId, companyId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Select_companyid: companyId,
            }
        }
    }
    return body
}

//取得同業壽險附約險種
export const getAdditionalInsuranceProduct = function(userId, companyId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                Select_companyid: companyId
            }
        }
    }
    return body
}

// 取得同業壽險主約商品的個別資訊
export const getProductDetail = function(userId, productId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Select_ProductId: productId
            }
        }
    }
    return body
}

//取得同業壽險附約商品的個別資訊
export const getAdditionalProductDetail = function(userId, productId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Select_ProductId: productId
            }
        }
    }
    return body
}

// 新增同業壽險主約
export const addOtherPrimaryContract = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                InsuredID: insData.targetId,
                InsuredName: insData.target,
                PolicyNumber: insData.no,
                productid: insData.insuranceType,
                Product: insData.insuranceName,
                YearPeriodToBuy: insData.years,
                PaymentWay: insData.pay,
                InsuranceDate: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                InsuranceAmount: insData.type,
                SchemeToBuy: insData.sum,
                Premium: insData.fee,
                InsuranceValue: insData.value,
                UnitNo: insData.unitNum,
                MinGuaranteeDieAmount: insData.min,
                MinGuaranteeDueMoney: insData.max,
                AnnuityDate: insData.payAt[0] !== '' ? `${insData.payAt[0]}-${insData.payAt[1]}-${insData.payAt[2]}` : '',
                Applicant: insData.client,
                SecondaryInsuredList: insData.processSubTarget,
                BeneficiaryOfDeath: insData.processDead,
                BeneficiaryOfMaturity: insData.processBeneficiary,
                BeneficiaryOfAnnuity: insData.processAnniversary,
                BeneficiaryOfGoodWish: insData.processCelebrate,
            }
        }
    }
    return body
}

// 新增同業壽險附約
export const addOtherAdditionalContract = function(userId, insData, policyID) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                PolicyID: policyID,
                AgentID: userId,
                productid: insData.productId,
                YearPeriodToBuy: insData.years,
                PaymentWay: insData.pay,
                InsuranceDate: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                // InsuranceDate: `${2018}-${insData.startAt[1]}-${insData.startAt[2]}`,
                InsuranceAmount: insData.type,
                SchemeToBuy: insData.sum,
                Premium: insData.fee,
                InsuranceValue: insData.value,
                InsuredID: insData.targetId,
                SecondaryInsuredList: insData.processSubTarget,
            }
        }
    }
    return body
}

export const deleteOtherContract = function(userId, personalId, policyId, contractId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                PersonalID: personalId,
                DeleteType: null === contractId ? 'a' : 'b',
                PolicyID: policyId,
                ContractID: contractId
            }
        },
    }
    return body
}

// 取得同業壽險保單之單張主約資訊
export const getPrimaryContractDetail = function(userId, policyId, contractId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                PolicyID: policyId,
                ContractID: contractId
            }
        }
    }
    return body
}

//新增國泰壽險
export const addCathayInsurance = function(userId, insurances) {
    let dataList = insurances.map(data => {
        return {
            InsuredID: data.insuredID,
            PolicyNumber: data.policyNumber
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                PolicyDataList: dataList
            }
        }
    }
    return body
}

// 取得同業壽險保單之單張附約資訊
export const getAdditionalContractDetail = function(userId, policyId, contractId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                PolicyID: policyId,
                ContractID: contractId
            }
        },
    }
    return body
}

// 查詢智能配對資料
export const querySmartMappingData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                reqData: reqData
            }
        }
    }
    return body
}

//服務件列表
export const queryAllocationList = function(userId, conditions) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: conditions
        }
    }
    return body
}

//編輯同業壽險附約
export const modifyOtherAdditionalContract = function(userId, form, policyID, contractID, primaryContractId) {
    let body = {
        header: {
            userId: userId,
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                AgentID: userId,
                PolicyID: policyID,
                ContractID: contractID,
                primaryContractId: primaryContractId,
                YearPeriodToBuy: form.years,
                PaymentWay: form.pay,
                InsuranceDate: `${form.startAt[0]}-${form.startAt[1]}-${form.startAt[2]}`,
                InsuranceAmount: form.type,
                Premium: form.fee,
                SchemeToBuy: form.sum,
                InsuranceValue: form.value,
                InsuredID: form.targetId,
                SecondaryInsuredList: form.processSubTarget,
            }
        }
    }
    return body
}

//編輯同業壽險主約
export const modifyOtherPrimaryContract = function(userId, form, policyID, contractID) {
    let body = {
        header: {
            userId: userId,
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                AgentID: userId, // AgentID	業務員ID	String
                PolicyID: policyID, // PolicyID	保單GUID	String	
                ContractID: contractID, // ContractID	契約GUID	String		
                Applicant: form.client, // Applicant	要保人	String
                InsuredID: form.targetId, // InsuredID	主被保人ID	String
                InsuredName: form.target, // InsuredName	主被保人姓名	String	
                PolicyNumber: form.no, // PolicyNumber	保單號碼	String	
                YearPeriodToBuy: form.years, // YearPeriodToBuy	年期	String	
                PaymentWay: form.pay, // PaymentWay	繳別	String	
                InsuranceDate: `${form.startAt[0]}-${form.startAt[1]}-${form.startAt[2]}`, // InsuranceDate	投保日期	String	
                InsuranceAmount: form.type, // InsuranceAmount	保額	String	
                Premium: form.fee, // Premium	保費	String	
                SchemeToBuy: form.sum, // SchemeToBuy	計畫別	String	
                InsuranceValue: form.value, // InsuranceValue	保單價值	String	
                UnitNo: form.unitNum, // UnitNo	單位數	String	
                MinGuaranteeDieAmount: form.min, // MinGuaranteeDieAmount	保證最低身故金額	String	
                MinGuaranteeDueMoney: form.max, // MinGuaranteeDueMoney	保證最低滿期金額	String	
                AnnuityDate: `${form.payAt[0]}-${form.payAt[1]}-${form.payAt[2]}`, // AnnuityDate	年金給付日	String		
                SecondaryInsuredList: form.processSubTarget,
                BeneficiaryOfDeath: form.processDead, // BeneficiaryOfDeath	身故受益人	String	
                BeneficiaryOfMaturity: form.processBeneficiary, // BeneficiaryOfMaturity	滿期受益人	String	
                BeneficiaryOfAnnuity: form.processAnniversary, // BeneficiaryOfAnnuity	年金受益人	String	
                BeneficiaryOfGoodWish: form.processCelebrate, // BeneficiaryOfGoodWish	祝壽金受益人	String	
            }
        }
    }
    return body
}
// 新增同業壽險車險
export const addMotorInsurances = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                GuId: insData.guid,
                Name: insData.target,
                InsuredID: insData.targetId,
                CompanyId: insData.companyId,
                CompanyShortName: insData.targetCompany,
                ContractType: insData.contractType,
                PolicyNumber: insData.policyNumber,
                LicensePlate: insData.licensePlate,
                EngineNumber: insData.engineNumber,
                Year: insData.years,
                DateInsurance: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                Premium: insData.premium,
                CarType: insData.carType,
                TargetBirth:insData.target_birth
            }
        }
    }
    return body
}

// 新增同業壽險火險
export const addFireInsurances = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                GuId: insData.guid,
                PolicyNumber: insData.policyNumber,
                CompanyId: insData.companyId,
                CompanyShortName: insData.targetCompany,
                ContractType: insData.contractType,
                Year: insData.years,
                Name: insData.target,
                InsuredID: insData.targetId,
                DateInsurance: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                Premium: insData.premium,
                TargetBirth:insData.target_birth
            }
        }
    }
    return body
}

// 新增同業壽險新種險
export const addNewTypeInsurances = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                GuId: insData.guid,
                Name: insData.target,
                InsuredID: insData.targetId,
                PolicyNumber: insData.policyNumber,
                CompanyId: insData.companyId,
                CompanyShortName: insData.targetCompany,
                ContractType: insData.contractType,
                Year: insData.years,
                DateInsurance: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                Premium: insData.premium,
                Famt: insData.famt
            }
        }
    }
    return body
}

// 新增其他保單筆記
export const addOtherInsuranceNote = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                GuId: insData.guid,
                Name: insData.target,
                Insured: insData.insured,
                Plcno: insData.plcno,
                CompanyId: insData.companyId,
                Compnm: insData.compnm,
                Contract_type_nm: insData.contract_type_nm,
                Insurancetype_nm: insData.insurancetype_nm,
                Prd: insData.prd,
                DateInsurance: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                Prem: insData.prem,
                Famt: insData.famt,
                Remark: insData.remark
            }
        }
    }
    return body
}

//編輯同業壽險車險
export const editMotorInsurances = function(userId, editData) {
    let body = {
        header: {
            userId: userId,
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                AgentID: userId, // AgentID	業務員ID	String
                PropertyID: editData.guid, // PropertyID	保單GUID	String	
                PolicyNumber: editData.policyNumber, // PolicyNumber	保單號碼	String	
                InsuredID: editData.targetId, // InsuredID	被保人ID	String
                FullName: editData.target, // FullName	被保人姓名	String	
                CompanyId: editData.companyId, // CompanyId	產險公司GUID	String		
                CompanyName: editData.targetCompany, // CompanyName	產險公司	String
                Year: editData.years, // Year	年期	Integer	
                ContractType: editData.contractType, // ContractType	契約別	String	
                DateInsurance: `${editData.startAt[0]}-${editData.startAt[1]}-${editData.startAt[2]}`, // DateInsurance	投保日期	String	
                LicensePlate: editData.licensePlate, // LicensePlate	車牌號碼	String	
                EngineNumber: editData.engineNumber, // EngineNumber	引擎號碼	String	
                Premium: editData.premium, // Premium	保費	Integer	
                CarType: editData.carType, // CarType	車種	String	
                TargetBirth: editData.target_birth, // CarType	車種	String	

            }
        }
    }
    return body
}

//編輯同業壽險火險
export const editFireInsurances = function(userId, editData) {
    let body = {
        header: {
            userId: userId,
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                AgentID: userId, // AgentID	業務員ID	String
                PropertyID: editData.guid, // PropertyID	保單GUID	String	
                PolicyNumber: editData.policyNumber, // PolicyNumber	保單號碼	String	
                InsuredID: editData.targetId, // InsuredID	被保人ID	String
                FullName: editData.target, // FullName	被保人姓名	String	
                CompanyId: editData.companyId, // CompanyId	產險公司GUID	String		
                CompanyName: editData.targetCompany, // CompanyName	產險公司	String
                Year: editData.years, // Year	年期	Integer	
                ContractType: editData.contractType, // ContractType	契約別	String	
                DateInsurance: `${editData.startAt[0]}-${editData.startAt[1]}-${editData.startAt[2]}`, // DateInsurance	投保日期	String	
                Premium: editData.premium, // Premium	保費	Integer	
                TargetBirth:editData.target_birth
            }
        }
    }
    return body
}

//編輯同業壽險新種險
export const editNewTypeInsurances = function(userId, editData) {
    let body = {
        header: {
            userId: userId,
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                AgentID: userId, // AgentID	業務員ID	String
                PropertyID: editData.guid, // PropertyID	保單GUID	String	
                PolicyNumber: editData.policyNumber, // PolicyNumber	保單號碼	String	
                InsuredID: editData.targetId, // InsuredID	被保人ID	String
                FullName: editData.target, // FullName	被保人姓名	String	
                CompanyId: editData.companyId, // CompanyId	產險公司GUID	String		
                CompanyName: editData.targetCompany, // CompanyName	產險公司	String
                Year: editData.years, // Year	年期	Integer	
                ContractType: editData.contractType, // ContractType	契約別	String	
                DateInsurance: `${editData.startAt[0]}-${editData.startAt[1]}-${editData.startAt[2]}`, // DateInsurance	投保日期	String	
                Premium: editData.premium, // Premium	保費	Integer
                Famt: editData.famt, // Famt	保額	Integer	
            }
        }
    }
    return body
}

// 編輯其他保單筆記
export const editOtherInsuranceNote = function(userId, insData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                GuId: insData.guid,
                Name: insData.target,
                Insured: insData.insured,
                Plcno: insData.plcno,
                CompanyId: insData.companyId,
                Compnm: insData.compnm,
                Contract_type_nm: insData.contract_type_nm,
                Insurancetype_nm: insData.insurancetype_nm,
                Prd: insData.prd,
                DateInsurance: `${insData.startAt[0]}-${insData.startAt[1]}-${insData.startAt[2]}`,
                Prem: insData.prem,
                Famt: insData.famt,
                Remark: insData.remark
            }
        }
    }
    return body
}

// 查詢同業壽險車、火、新種險
export const getAllInsurances = function(userId, custId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            AgentID: userId,
            MemberId: custId
        }
    }
    return body
}

// 查詢同業公司列表
export const getAllCompany = function(userId, custId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            AgentID: userId,
            MemberId: custId ? custId : serNo
        }
    }
    return body
}

// 查詢服務件地圖列表
export const getGoogleMapLocation = function(userId, formData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
            // userId: 'S18990655I'  // for test 測試用
        },
        body: {
            conditions: {
                type: formData.type || '', // type	首頁篩選方式
                cedvno3: formData.cedvno3 || '', // cedvno3	單位代號前3碼
                clcno_old: formData.clcno_old || '', // clcno_old	撥出代號(單選)
                ceplcno: formData.ceplcno || '', // ceplcno	保單號碼
                ceapcno: formData.ceapcno || '', // ceapcno	要保人ID
                zip: formData.zip || '', // zip	郵遞區號
                addr: formData.addr || '', // addr	路段名稱
                segment_clcno: formData.segment_clcno || [], // segment_clcno	選取的撥出類別
                // segment_old: formData.segment_old || '',  // segment_old	選取的撥出類別
                clcno_old_list: formData.clcno_old_list || [], // clcno_old_list	選取的撥出代號(多個)
                clcno_new: formData.clcno_new || '', // clcno_new	選取的撥入代號
                cusname: formData.clientName || '', // cusname	篩選客戶姓名
                now_ex: formData.charger[0] || '', // now_ex	篩選現行/前手
                ceclcnm: formData.charger[1] || '', // ceclcnm	篩選收費人員姓名
                is_vip: formData.vip || '', // is_vip	篩選vip
                ceagent: formData.self || '', // ceagent	篩選自招/非自招
                zip_filter: formData.address[1] || '', // zip_filter	篩選地區郵遞區號
                addr_filter: formData.address[2] || '', // addr_filter	篩選路段名稱
                selected_plcno: formData.selected_plcno || [], // selected_plcno	已勾選保單
            }
            // conditions: {   // for test 測試用
            //   type: "1",     // type	首頁篩選方式
            //   cedvno3: "EB1",  // cedvno3	單位代號前3碼
            //   clcno_old: "EB13038",  // clcno_old	撥出代號(單選)
            //   ceplcno: "",  // ceplcno	保單號碼
            //   ceapcno: "",  // ceapcno	要保人ID
            //   zip: "",  // zip	郵遞區號
            //   addr: "",  // addr	路段名稱
            //   segment_old: "",  // segment_old	選取的撥出類別
            //   clcno_old_list: "",  // clcno_old_list	選取的撥出代號(多個)
            //   clcno_new: "EB1289A", // clcno_new	選取的撥入代號
            //   cusname: "",  // cusname	篩選客戶姓名
            //   now_ex: "",  // now_ex	篩選現行/前手
            //   ceclcnm: "",  // ceclcnm	篩選收費人員姓名
            //   is_vip: "",  // is_vip	篩選vip
            //   ceagent: "",  // ceagent	篩選自招/非自招
            //   zip_filter: "",  // zip_filter	篩選地區郵遞區號
            //   addr_filter: "",  // addr_filter	篩選路段名稱
            //   // selected_plcno: [],  // selected_plcno	已勾選保單
            //   selected_plcno: ["9002134877", "7244885432", "9118012035"],  // selected_plcno	已勾選保單
            // }
        }
    }
    return body
}

// 查詢拜訪紀錄自訂標籤
export const getCustVisitItem = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            AY_D0Z015_bo: {
                AGIDNO: userId
            }
        }
    }
    return body
}

// 刪除同業保單列表
export const deleteOtherInsurances = function(userId, propertyId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                PropertyID: propertyId
            }
        }
    }
    return body
}

// 查詢轄下撥出人員(小額調撥)
export const getOutTransferMember = function(userId, cedvno3, clcno5) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                clcno5: clcno5,
                segment: "O"
            }
        }
    }
    return body
}

// 查詢拜訪紀錄固定標籤
export const getCustDefaultItem = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                div_no: store.state.userInfo.divNo
            }
        }
    }
    return body
}

// 編輯拜訪紀錄
export const editVisitRecord = function(userId, custId, recordInfo, form, selectOpt) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: "U",
            conditions: {
                csid: custId,
                agid: userId,
                note_string: form.note || '',
                record_string: form.title || '',
                referral1: recordInfo.REFERRAL1 || '',
                referral2: recordInfo.REFERRAL2 || '',
                referral_companynm: recordInfo.REFERRAL_COMPANYNM || '',
                meetings_topic: recordInfo.MEETINGS_TOPIC || '',
                meetings_num: recordInfo.MEETINGS_NUM || '',
                event_year: recordInfo.EVENT_YEAR || '',
                event_ser_no: recordInfo.EVENT_SER_NO || '',
                record_symbol: recordInfo.RECORD_SYMBOL || '',
                ismiss: recordInfo.ISMISS || '',
                isdone: recordInfo.ISDONE || '',
                sub_cls_code: selectOpt || '',
                source: "CRM",
                event_date: recordInfo.EVENT_DATE,
            }
        }
    }
    return body
}

// 編輯常用標籤
export const editCustItem = function(userId, form) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            AY_D0Z015_bo: {
                AGIDNO: userId,
                CLS_NM_1: form[0].name,
                CLS_NM_2: form[1].name,
                CLS_NM_3: form[2].name,
                CLS_NM_4: form[3].name,
                CLS_NM_5: form[4].name,
                SOURCE: "CRM",
            }
        }
    }
    return body
}

// 查詢轄下撥入人員(小額調撥)
export const getInTransferMember = function(userId, cedvno3, clcno5) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                cedvno3: cedvno3,
                clcno5: clcno5,
                segment: "I"
            }
        }
    }
    return body
}


// 刪除拜訪紀錄
export const deleteVisitRecord = function(userId, data) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: "D",
            conditions: {
                agid: userId,
                event_year: data.EVENT_YEAR,
                event_ser_no: data.EVENT_SER_NO,
                sub_cls_code: data.SUB_CLS_CODE,
            }
        }
    }
    return body
}

//查詢當日已覆核清單
export const getSPlList = function(userId, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: '1',
            cedvno3: cedvno3
        }
    }
    return body
}

//覆核作業_查詢服務件調撥清單
export const getServiceTransferList = function(userId, div_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            div_no: div_no
        }
    }
    return body
}

//覆核作業_取消覆核服務件調撥
export const reviewServiceTransferList = function(userId, reviewList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reviewList: reviewList
        }
    }
    return body
}

//查詢前主管服務件自留清單
export const getFormerSupervisorServiceList = function(userId, div_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            div_no: div_no
        }
    }
    return body
}

//覆核前主管服務件自留清單
export const reviewFormerSupervisorServiceList = function(userId, reviewList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reviewList: reviewList
        }
    }
    return body
}

//執行取消檔日已覆核
export const cancelSPl = function(userId, cedvno3, updateList) {
    let update_r1 = [];
    let update_r2 = [];
    let update_r3 = [];
    updateList.forEach(data => {
        switch (data.type) {
            case '小額調撥':
                let r1data = {
                    plcno: data.plcno,
                    cedvno3: cedvno3,
                    ceapcno: data.ceapcno,
                    ceclcno_old: data.ceclcno_old
                }
                update_r1.push(r1data)
                break;
            case '實質接觸排除':
                let r2data = {
                    visit_no: data.visit_no
                }
                update_r2.push(r2data)
                break;
            case '失聯件排除':
                //let r3data = {
                //  visit_no: data.visit_no
                //}
                //update_r3.push(r3data)
                //新的排除 
                update_r3.push(data)
                break;
        }
    })
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: '2',
            update_r1: update_r1,
            update_r2: update_r2,
            update_r3: update_r3
        }
    }
    return reqBody
}

// 查詢未訪件業務員清單
export const queryEstrangeAgList = function(userId, cedvno3) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: 'queryAg',
            cedvno3: cedvno3
                // cedvno3: "AH4"
        }
    }
    return reqBody
}

// 查詢未訪件客戶清單
export const queryEstrangePlList = function(userId, cedvno3, ceclcno) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: 'queryPl',
            cedvno3: cedvno3,
            ceclcno: ceclcno
                // ceclcno: "AH54776",
                // cedvno3: "AH4"
        }
    }
    return reqBody
}

// 覆核排除未訪件
export const modifyEstrangePl = function(userId, cedvno3, dataList) {
    let updateData = dataList.map(eachObj => {
        eachObj['mgr_id'] = userId,
            eachObj['cedvno3'] = cedvno3,
            eachObj['exclude'] = 1
        return eachObj
    })
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: 'update',
            update_list: updateData
        }
    }
    return reqBody
}

// 查詢轄下未訪件人員
export const queryBelowEstrangeAg = function(userId, clcno_lv) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: "1",
                clcno_lv: clcno_lv
            }
        }
    }
    return reqBody
}

// 轄下未訪件資訊
export const queryBelowEstrangePolicy = function(userId, ceclcid) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: "2",
                ceclcid: ceclcid
            }
        }
    }
    return reqBody
}

// 查詢轄下未訪件資訊之保戶通聯資料IAA
export const queryBelowEstrangePolicyContactInfo = function(userId, ceapcno, ceapcnm) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                csid: ceapcno,
                name: ceapcnm
            }
        }
    }
    return reqBody
}

// 查詢調撥記錄清單
export const queryRechargeRecord = function(userId, cedvno3, api_id, cedvno3_out, cedvno3_in) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: api_id,
                cedvno3: cedvno3,
                    // cedvno3: "FN4"
                cedvno3_out: cedvno3_out,
                cedvno3_in: cedvno3_in
            }
        }
    }
    return reqBody
}

// 查詢調撥記錄名細
export const queryRechargeRecordDetail = function(userId, ceclcid_old, ceclcno_old, ceclcid_new, ceclcno_new, producer_segment, date) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: "2",
                // ceclcid_old: "A18951455F",
                // ceclcno_old: "FN52R99",
                // ceclcid_new: "L18922226G",
                // ceclcno_new: "FN521",
                // producer_segment: "D",
                // date: "2019-04-25",
                ceclcid_old: ceclcid_old,
                ceclcno_old: ceclcno_old,
                ceclcid_new: ceclcid_new,
                ceclcno_new: ceclcno_new,
                producer_segment: producer_segment,
                date: date
            }
        }
    }
    return reqBody
}

// 覆核小額調撥_取得未覆核名單
export const queryNreChargeList = function(userId, divNo, action) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
                // userId: 'H28950545H'
        },
        body: {
            action: action,
            report: {
                mktdeptno: divNo
                    // mktdeptno: 'A8100'
            }
        }
    }
    return reqBody
}

// 覆核小額調撥_確認覆核
// report 為 ArrayList<Object> object內key為 ceplcno, cedvno3, ceclcid_new, ceclcno_new, ceclcno, ceapcn
export const confirmNreCharge = function(userId, userName, data, divNo) {
    let report = data.map(item => {
        // item['cedvno3'] = item.ceclcar.slice(0,3)  //ceclcar為必回傳欄位,故不會出現undefined
        let temp = {
            // pl_1
            ceplcno: item.ceplcno,
            cedvno3: divNo.slice(0, 3),
            ceclcid_new: item.ceclcid_new,
            ceclcno_new: item.ceclcno_new,
            // pl_2
            ceclcno: item.ceclcno,
            ceapcno: item.ceapcno
        }
        return temp
    })
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            name: userName,
            cedvno: divNo,
            report: report
        }
    }
    return reqBody
}

// 覆核小額調撥_退回覆核
//ceplcno List<String>
export const deleteNreCharge = function(userId, ceplcno) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                ceplcno: ceplcno
            }
        }
    }
    return reqBody
}

// 查詢覆核失聯件排除
export const queryChangeNcontact = function(userId, clcno_lv, startDate, endDate) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            query: {
                // cedvno3: "EB1",
                // sd: "2001-01-01",
                // ed: "2019-12-31"
                clcno_lv: clcno_lv,
                sd: startDate,
                ed: endDate
            }
        }
    }
    return reqBody
}

// 覆核小額調撥_取得未覆核名單
export const queryForNAPServiceData = function(userId, divNo) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            div_no: divNo,
        }
    }
    return reqBody
}

// 覆核更新失聯件
export const updateChangeNcontact = function(userId, visitNoArray) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            update: visitNoArray
                // update: ["G092198283"]
        }
    }
    return reqBody
}

// 服務件調撥寫入記錄
export const insertServiceRecord = function(userId, type, policyList, AgInfo, clcno, userName) {
    let fordata = policyList.map(item => { // 轉換成 request 格式
        return {
            ceplcno: item.ceplcno || '', //保單號碼
            idmark: item.idmark || '', //身分註記
            ceapcno: item.ceapcno || '', //客戶ID
            ceapcnm: item.ceapcnm || '', //客戶姓名
            ceclcid: item.ceclcid || '', //現行收費人員ID
            ceclcnm: item.ceclcnm || '', //現行收費人員姓名
            ceclcno: item.ceclcno || '', //現行收費代號
            ceagent: item.ceagent || '', //是否自招件
            zip_code: item.zip_code || '', //整合地址郵遞區號
            d2_payaddr: item.d2_payaddr || '', //整合地址
            celpscm_nm: item.celpscs_nm || '', //契約效力
            ceclcnm_old: item.ceclcnm_old || '', //前一收費人員姓名
            ceclcno_old: item.ceclcno_old || '', //前一收費代號
            cenxpdt: item.cenxpdt || '', //下次應繳日
            deadline: item.deadline || '', //調撥截止日
            sum_ceplcno: item.sum_ceplcno || '', //保單數
            l_relation: item.l_relation || '', //開發價值
            d1_payaddr: item.d1_payaddr || '', //收費地址
            ceclcar: item.ceclcar || '', //現行收費單位代號
            producer_segment: item.producer_segment || '', //撥出類別
            jcode: item.jcode || '', //現行收費人員職級
            tmp4: item.tmp4 || '', //應撥出件數
            tmp4: item.mgr_nm || '', //主管名
        }
    })
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                type: type,
                policy_list: fordata,
                inag_info: {
                    ceclcid_new: AgInfo.ceclcid_new || '', //新收費人員ID
                    ceclcnm_new: AgInfo.ceclcnm_new || '', //新收費人員姓名
                    producer_segment_in: AgInfo.producer_segment_in || '', //撥入類別
                    tmp4_in: AgInfo.tmp4_in || '', //應撥入件數
                    jcode_new: AgInfo.jcode_new || '', //新收費人員職級
                    ceclcar_new1: AgInfo.ceclcar_new1 || '', //新收費單位代號
                    clcno_new: clcno, //新收費人員代號
                },
                user_name: userName,
            }
        }
    }
    return reqBody
}

// 服務件調撥寫入記錄(智能配對)
export const insertServiceRecord2 = function(userId, selection, userName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {         
                selection: selection,
                user_name: userName
            }
        }
    }
    return body
}

//刪除國泰壽險
export const deleteCathayInsurance = function(userId, insurances) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AgentID: userId,
                DeleteLifeInsuranceList: [insurances]
            }
        }
    }
    return body
}

//查詢搜尋紀錄前八筆
export const getSearchRecordFirstEight = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 查詢拜訪件人員
export const queryChangeNEag = function(userId, divNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            query_Eag: {
                cedvno3: divNo.slice(0, 3)
            }
        }
    }
    return body
}

// 查詢拜訪排除
export const queryChangeNIsexc = function(userId, divNo, starDay, endDay, clcno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            query_Isexc: {
                cedvno3: divNo.slice(0, 3),
                sd: starDay,
                ed: endDay,
                clcno: clcno
            }
        }
    }
    return body
}

// 更新拜訪排除
export const updateChangeNIsexc = function(userId, visitNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            update: {
                visit_no: visitNo.map(item => { return item.visit_no })
            }
        }
    }
    return body
}

// 儲存家戶之成員
export const submitFamilyMembers = function(userId, custid, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                agid: userId,
                csid: custid,
                familyMemberList: insertData,
            }
        }
    }
    return body
}

// 建議調撥(全單位未訪件)
// lev1:全部, (yearq, monq)
// lev2:區部, (yearq, monq, cedvno)
// lev3:通訊處, (yearq, monq, cedvno)
// lev44:展業課, (cedvno)
// lev51:專招推展處, (cedvno)
// lev54:展業區, (cedvno)
// lev6:人員, (cedvno)
export const queryStatsBZ = function(userId, level, westYear, month, cedvno) {
    let monthQ = ''

    if (month.length == 1) {
        monthQ = `${westYear}0${month}`
    } else {
        monthQ = `${westYear}${month}`
    }

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: level,
            report: {
                yearq: westYear,
                monq: monthQ,
                cedvno: cedvno,
            }
        }
    }
    return body
}

export const downloadStatsBZ = function(userId, level, westYear, month, cedvno) {
    let monthQ = ''

    if (month.length == 1) {
        monthQ = `${westYear}0${month}`
    } else {
        monthQ = `${westYear}${month}`
    }

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: level,
            report: {
                yearq: westYear,
                monq: monthQ,
                cedvno: cedvno,
            }
        }
    }
    return body
}

// 轄下未訪件接觸追蹤表
// lev1:全部, (startDate, endDate)
// lev2:區部, (startDate, endDate, cedvno)
// lev3:通訊處, (startDate, endDate, cedvno)
// lev44:展業課, (startDate, endDate,cedvno)
// lev51:專招推展處, (startDate, endDate,cedvno)
// lev54:展業區, (startDate, endDate,cedvno)
// lev6:人員, (startDate, endDate,cedvno)
export const queryStatsBZEST = function(userId, level, startDate, endDate, cedvno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: level,
            // cedvno: "EB1",
            // yearq: "2001-01-01",
            // monq: "2019-12-31"
            report: {
                yearq: startDate,
                monq: endDate,
                cedvno: cedvno,
            }
        }
    }
    return body
}

export const downloadStatsBZEST = function(userId, level, startDate, endDate, cedvno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: level,
            report: {
                yearq: startDate,
                monq: endDate,
                cedvno: cedvno,
            }
        }
    }
    return body
}

// 查詢覆核記錄
export const queryApproveRecord = function(userId, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '1',
                cedvno3: cedvno3,
                // cedvno3: 'EB1'
            }
        }
    }
    return body
}

// 查詢失聯件覆核明細
export const queryLostConfirmDetail = function(userId, agid, csid, clcno, cdate) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '2',
                // cdate: "2019-07-05",
                // agid: "E28786977H",
                // clcno: "EB1319A",
                // csid: "X18679477D",
                agid: agid,
                csid: csid,
                clcno: clcno,
                cdate: cdate,
            }
        }
    }
    return body
}

// 查詢實質接觸排除明細
export const queryNoticeExcludeDetail = function(userId, agid, csid, clcno, cdate, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '3',
                // cedvno3: "EB1",
                // cdate: "2019-07-05",
                // agid: "S18630857I",
                // clcno: "EB13137",
                // csid: "E18702913H",
                agid: agid,
                csid: csid,
                clcno: clcno,
                cdate: cdate,
                cedvno3: cedvno3,
            }
        }
    }
    return body
}

// 查詢未訪件排除明細
export const queryEstrangeExcludeDetail = function(userId, agid, csid, clcno, cdate) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '4',
                // cdate: "2019-07-05",
                // agid: "E18676101A",
                // clcno: "EB13599",
                // csid: "A26860479I"
                agid: agid,
                csid: csid,
                clcno: clcno,
                cdate: cdate,
            }
        }
    }
    return body
}

//「回到舊CRM」寫Log
export const insertOldCRMLoginLog = function(userId, depno, divno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                AG_ID: userId,
                depno: depno,
                DVNO: divno,
            }
        }
    }
    return body
}

// 取回所有單位代號及對象總人數
export const getTacount = function(userId, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                divno: report.divno,
                isdepno: report.isdepno,
                depno: report.depno,
            }
        }
    }
    return body
}

// 單位佈告欄-新增訊息
export const releaseAddNews = function(userId, formData, file = '') {
    let form = new FormData()
    if (file !== '') {
        form.append("file", file, file.name)
    }
    // formData['FILE'] = file
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: formData,
        }
    }
    form.append("json", JSON.stringify(body))

    return form
}

// 查異動後實質接觸-查詢名細
export const getChangeNotice = function(userId, asc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '1',
                agid: userId,
                asc: asc
            },
        }
    }
    return body
}

// 查異動後實質接觸-查詢名細
export const getChangeNotice_csid = function(userId, custids) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: '6',
                agid: userId,
                custIDList: custids
            },
        }
    }
    return body
}

// 查詢是否有異動後實質接觸名細
export const checkNotice = function(agid, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agid,
        },
        body: {
            conditions: {
                api_id: '5',
                agid: agid,
                csid: csid
            },
        }
    }
    return body
}

//公版聯繫函_查詢(聯繫關係、客戶資訊、單位資訊)
export const contactLetter = function(api_id, agid, csid, cedvno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agid,
        },
        body: {
            conditions: {
                api_id: api_id,
                agid: agid,
                csid: csid,
                cedvno: cedvno
            },
        }
    }
    return body
}

// 單位佈告欄-查詢點閱率
export const queryClickRate = function(userId, divno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                agidno: userId,
                divno: divno
            }
        }
    }
    return body
}
// 查異動後實質接觸-查詢列印
export const getChangePrint = function(userId, custId, visitNo, cedvno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "2",
                agid: userId,
                csid: custId,
                visit_no: visitNo,
                cedvno: cedvno,
            },
        }
    }
    return body
}

// 查異動後實質接觸-查詢列印(多筆))
export const getChangePrint_all = function(userId, custId, visitNo, cedvno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "7",
                agid: userId,
                csidList: custId,
                visit_noList: visitNo,
                cedvno: cedvno,
            },
        }
    }
    return body
}

// 異動後實質接觸-列印、公版聯繫函-列印
export const showChangePDF = function(userId, param) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            param
        }
    }
    return body
}

// 查異動後實質接觸-查詢回報
export const getChangeReprot = function(userId, visitNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "3",
                visit_no: visitNo,
            },
        }
    }
    return body
}
// 單位佈告欄-已下架查詢點閱率
export const queryOldClickRate = function(userId, divno, startDate, endDate, subjectKeyWord) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: 'N18821725E',
            userId: userId
        },
        body: {
            report: {
                agidno: userId,
                divno: divno,
                start_date: startDate,
                end_date: endDate,
                subject_key_word: subjectKeyWord
                    // agidno: "A125685019",
                    // start_date: "2001-01-01",
                    // end_date: "2020-12-25",
                    // subject_key_word: "常見"        
            }
        }
    }
    return body
}

// 查異動後實質接觸-更新回報
export const getChangeUpdateReprot = function(userId, custId, contact) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "4",
                agid: userId,
                csid: custId,
                contact: contact,
            },
        }
    }
    return body
}

// 單位佈告欄-編輯訊息
export const modifyNews = function(userId, form) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                ser_no: form.ser_no,
                end_date: form.end_date,
                upd_id: form.upd_id,
                upd_nm: form.upd_nm,
                words: form.words,
            },
        }
    }
    return body
}
//最新消息_LOG
export const insertNewsLog = function(userId, ceadcd, div_no, ser_no, isclicktitle, islinkway) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agidno: userId,
            ceadcd: ceadcd,
            div_no: div_no,
            ser_no: ser_no,
            isclicktitle: isclicktitle,
            islinkway: islinkway,
        }
    }
    return body
}

// 名單專區-首頁資訊
export const getListArea = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agentid: userId
        }
    }
    return body
}

// 新增首頁查詢關鍵字的Log
export const setKeyWordLog = function(searchkeyword) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            report: {
                searchkeyword: searchkeyword
            }
        }
    }
    return body
}

// 新增滿意度調查
export const setSatisfactionSurvey = function(userId, cate_serno, satisfy_range, recommand_txt) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            cate_serno: cate_serno,
            satisfy_range: satisfy_range,
            recommand_txt: recommand_txt
        }
    }
    return body
}

// 查詢是否完成滿意度調查
export const isSatisfactionSurveyFinish = function(userId, cate_serno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            cate_serno: cate_serno
        }
    }
    return body
}

// 查詢強制調撥總表
export const getmandatoryAllocationSummary = function(userId, api_id, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            report: {
                qs: report.startDate,
                qe: report.endDate,
                ceadcd: report.ceadcd,
                monthChk: report.monthChk
            }
        }
    }
    return body
}

// 名單專區各個首頁資訊
export const getCategoryInfo = function(userId, categor) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            category: categor,
        }
    }
    return body
}

// 強制調撥離退職人員撥出
export const forcedTransferPersonnel = function(userId, api_id, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            report: {
                qs: report.startDate,
                qe: report.endDate,
                ceadcd: report.ceadcd
            }
        }
    }
    return body
}

// 取得專區資訊
export const getCategoryDetail = function(userId, ser_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            ser_no: ser_no,
        }
    }
    return body
}

//查詢舊拜訪紀錄
export const queryOldCRMRecord = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                csid: csid,
                agnt_id: userId
                    // csid: "E26713607B",
                    // agnt_id: "A18711163G"
            }
        }
    }
    return body
}

//查詢單位佈告欄成效檢視
export const queryUnitBulletinEffect = function(userId, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                showclass: report.showclass,
                agidno: userId,
                devno: report.devno,
                ser_no: report.ser_no,
            }
        }
    }
    return body
}


//取得異動後實質接觸追蹤表
export const getChangeTrace = function(userId, api_id, is_vip, start_date, end_date, group) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                // api_id: "1",
                // is_vip: "0",
                // start_date: "2019-01-01",
                // end_date: "2019-07-31",
                // group: "A400000",
                api_id: api_id,
                is_vip: is_vip,
                start_date: start_date,
                end_date: end_date,
                group: group
            }
        }
    }
    return body
}

//轄下異動後實質接觸人員
export const getChangePeople = function(userId, clcno_lv) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "1",
                clcno_lv: clcno_lv,
            }
        }
    }
    return body
}

//轄下異動後實質接觸明細
export const getChangeDetail = function(userId, cedvno3, clcno_lv, start_date, end_date, clcid, is_vip) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "2",
                cedvno3: cedvno3, //單位代號前3碼
                clcno_lv: clcno_lv, //收費代號層級
                start_date: start_date, //查詢起日
                end_date: end_date, // 查詢迄日
                clcid: clcid, // 收費人員ID
                is_vip: is_vip,
            }
        }
    }
    return body
}

//查詢受益量多名單
export const getMoreBenefits = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: '62'
            }
        }
    }
    return body
}

//查詢受益量多名單(潛力新客)
export const getHighPotentialNewCustomer = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 查詢缺醫不可名單
export const getMedicalCare = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 查詢三倍醫靠名單
export const getTripleCare = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 查詢商品行銷客戶名單
export const queryBoxCustomer = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 查詢一件鐘情名單
export const getOneLove = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: '64'
            }
        }
    }
    return body
}

// 2年內新人AFP/FCP撥入
export const newcomerDialinWithin = function(userId, api_id, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: "A28978309I",
            userId: userId
        },
        body: {
            api_id: api_id,
            // qs: "2017-01-01",
            // qe: "2019-07-30",
            qs: report.startDate,
            qe: report.endDate,
            ceadcd: report.ceadcd
        }
    }
    return body
}

//查詢轄下服務件資訊
export const queryNrechargeInfo = function(userId, api_id, group, cedvno, ceadcd, roleId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            conditions: {
                cedvno: cedvno,
                ceadcd: ceadcd,
                group: group
            },
            role_id: roleId
        }
    }
    return body
}


// 下載轄下服務件資訊
export const downloadNrechargeInfo = function(userId, api_id, roleId, group, cedvno, ceadcd) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            conditions: {
                roleId: roleId,
                cedvno: cedvno,
                ceadcd: ceadcd,
                group: group
            }
        }
    }
    return body
}

// 下載轄下服務件資訊(區處)
export const downloadNrechargeInfo2 = function(userId, roleId, cedvno, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            conditions: {
                roleId: roleId,
                cedvno: cedvno,
            }
        }
    }
    return body
}

// 下載區部未訪件資訊
export const downloadRegionalUnvisitedInfo = function(userId, cedvno3, api_id, segmentName) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            conditions: {
                cedvno3: cedvno3,
                segmentCode: api_id,
                segmentName: segmentName
            }
        }
    }
    return body
}

// 全單位未訪件
export const allUnitdetachment = function(userId, api_id, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: "A28978309I",
            userId: userId
        },
        body: {
            api_id: api_id,
            // qs: "2017-01-01",
            // qe: "2019-07-30",
            qs: report.startDate,
            qe: report.endDate,
            ceadcd: report.ceadcd
        }
    }
    return body
}

//單位條件篩選-查詢條件發佈後的使用狀況
export const queryconditions = function(userId, divno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: "H28950545H",
            userId: userId
        },
        body: {
            report: {
                // agidno: "H28950545H"
                agidno: userId,
                divno: divno
            }
        }
    }
    return body
}

//單位條件篩選-查詢已下架的單位條件
export const queryoffconditions = function(userId, divno, start_date, end_date) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            // userId: "H28950545H",
            userId: userId
        },
        body: {
            report: {
                // agidno: "H28950545H",
                // start_date: "2011-01-01",
                // end_date: "2019-12-31",
                agidno: userId,
                divno: divno,
                start_date: start_date,
                end_date: end_date
            }
        }
    }
    return body
}

// 調撥進度查詢
export const allocationStatusProcess = function(userId, agid, api_id, plcno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: api_id, //1 - 查詢進度 , 2 - 查詢當日已覆核人數 , 3 - 取消覆核
                agid: agid, // 1 , 2 必要
                plcno: plcno // 3 必要
            }
        }
    }
    return body
}

// 新增單位條件篩選
export const inserUnitCondition = function(userId, reprotData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                devno: reprotData.devno, // 單位代號
                agnt_id: userId, // 申請者的ID
                agnt_name: reprotData.agnt_name, // 申請人姓名
                applydate: reprotData.applydate, // 申請日期
                devfilter_name: reprotData.devfilter_name, // 條件組合的名稱
                option_ch: reprotData.opt_ch, // 	選項的中文
                conditions: reprotData.conditions, // 	條件清單
                upload_date: reprotData.upload_date, // 	發佈日期
                end_date: reprotData.end_date, // 	下架日期
                modifydate: reprotData.modifydate, // 	編輯日期
            }
        }
    }
    return body
}

// 客戶數預覽
export const getUnitCustCount = function(userId, divno, reprotData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                divno: divno,
                firstcount: reprotData.firstcount,
                option_ch: reprotData.option_ch,
                conditions: reprotData.conditions,
            }
        }
    }
    return body
}

// 編輯單位條件
export const modifyCondition = function(userId, end_date, devfilter_name, serno, upload_date) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                devfilter_serno: serno,
                end_date: end_date,
                upload_date: upload_date,
                devfilter_name: devfilter_name,
            }
        }
    }
    return body
}

// 單位條件_成效檢視
export const getEffective = function(userId, showclass, devno, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agidno: userId, // 業務員ID
                showclass: showclass, // 顯示的層級
                devno: devno, // 單位代號
                ser_no: serNo, // 單位條件篩選的流水編號
            }
        }
    }
    return body
}

// 服務權益-VIP專區-尊榮服務(符合資格)
export const getHonorService = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-推動名單(升/降等)
export const getPushList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-迎賓禮(符合資格)
export const getWelcomeCeremony = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-健康禮(符合資格) 
export const getHealthCeremony = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-保單活化查詢 
export const getInsuranceActivation = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-易Call保待重簽名單查詢
export const getEcllServiceItem = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-國泰一家人(家庭服務)
export const getCathayFamily = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "1",
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-國泰一家人(家庭服務)列印
export const getCathayFamilyPrint = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "2",
            report: {
                agnt_id: userId // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-國泰一家人(健康優禮)
export const getCathayFamilyPresent = function(userId, csid, csname) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "3",
            report: {
                agnt_id: userId, // 業務員ID
                csid: csid, //戶長ID
                csname: csname //戶長姓名
            }
        }
    }
    return body
}

// 服務權益-VIP專區-國泰一家人(權益服務)
export const getCathayFamilyBenefits = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "4",
            report: {
                agnt_id: userId, // 業務員ID
                csid: csid, //客戶ID
            }
        }
    }
    return body
}

// 服務權益-VIP專區-免費健檢(符合資格)
export const getFreeHealthCheck = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 服務權益-停效保單查詢
export const getStopEffctivePolicy = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: userId // 業務員ID
            },
        },
    }
    return body
}

// 查詢主管推薦by條件篩選
export const queryDevCondition = function(userId, divNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            divNo: divNo
        }
    }
    return body
}

// 單位條件的Log_主管推薦
export const queryDevConditionLog = function(userId, serNo, divNo, depNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            devfilter_serno: serNo,
            divNo: divNo,
            mktDeptNo: depNo,
        }
    }
    return body
}

// 名單專區-線上諮詢
export const getOnlineConsultation = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: '12'
            }
        }
    }
    return body
}

// 名單專區-公教長照
export const getLongTermCare = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: '18'
            }
        }
    }
    return body
}

// 新增客戶備註
export const insertMemo = function(userId, csid, memo, custType) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: '2',
                agid: userId,
                csid: csid,
                memo: memo,
                upd_source: '1',
                custType: custType
            }
        }
    }
    return body
}

// 修改客戶備註
export const modifyMemo = function(userId, csid, memo, custType) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: '3',
                agid: userId,
                csid: csid,
                memo: memo,
                upd_source: '1',
                custType: custType
            }
        }
    }
    return body
}

// 名單專區_外幣匯款手續費優惠
export const getForeignCurrencyHandleDiscount = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 名單專區_即將停效
export const getWillStopEffect = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "15"
            }
        }
    }
    return body
}

// 名單專區_停效後半年
export const getStopEffectAfter = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "16"
            }
        }
    }
    return body
}

// 名單專區_保單給付應領未領
export const getWarrantyShouldReceiveNotReceive = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
            }
        }
    }
    return body
}



// 名單專區_未兌現支票
export const getUnpaidCheck = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
            }
        }
    }
    return body
}

// 名單專區_滿期年金未辦
export const getFullAnnuityNotHandle = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
            }
        }
    }
    return body
}

// 名單專區_身心障礙
export const getPhysicalMentalDisorder = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "16"
            }
        }
    }
    return body
}

//名單專區-國泰伴你健康
export const getCathayWithYourHealth = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "15"
            }
        }
    }
    return body
}

//名單專區_小額終老
export const getSmallAmountOldAge = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "19"
            }
        }
    }
    return body
}

//名單專區_樂安心保
export const getHappyMindInsurance = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "20"
            }
        }
    }
    return body
}

//名單專區_未訪件預警 / 準未訪件明細
export const getRemoteDocumentWarning = function(userId, apiID) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: apiID,
                agid: userId
            }
        }
    }
    return body
}

//名單專區_未訪件預警-是否失聯 / 準未訪件明細-是否失聯
export const getRemoteDocumentWarningLost = function(userId, ceapcno, contact, isRemote) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                api_id: '2',
                agid: userId,
                ceapcno: ceapcno,
                contact: contact,
                isRemote: isRemote ? "Y" : "N"
            }
        }
    }
    return body
}

//名單專區_證卷數位服務
export const getSecuritiesDigitalService = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "14"
            }
        }
    }
    return body
}

//名單專區_高資產複委託
export const getHighAssetsRedelegation = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agid: userId,
                SRCH_TYPE: "17"
            }
        }
    }
    return body
}

//單位條件篩選_直接下架
export const conditionDown = function(userId, downData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                devfilter_serno: downData.devfilter_serno,
                end_date: downData.end_date
            }
        }
    }
    return body
}

// 名單專區-約定扣款獎勵活動名單
export const getAgreedDeduction = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
            }
        }
    }
    return body
}

// 名單專區-約定扣款獎勵活動要保人目標保單明細
export const getAgreedDeductionDetail = function(userId,apcId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId, // 業務員ID
                apc_id: apcId, // 要保人ID
            }
        }
    }
    return body
}


//授權管理_查詢轄下可授權人員
export const getAuthorizedPersonnel = function(userId, divno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                divno: divno,
            }
        }
    }
    return body
}

//授權管理_設定權限
export const setPermissionsAuthorized = function(userId, form, lists) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                div_full_name: form.div_full_name,
                name: form.name,
                employee_id: form.employee_id,
                div_no: form.div_no,
                user_category_id: form.user_category_id,
                function_list: lists
            }
        }
    }
    return body
}

// 最新消息下載檔案
export const downloadFile = function(userId, ser_no, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            ser_no: ser_no,
            filename: filename,
        }
    }
    return body
}

// 下載服務件調撥操作手冊
export const downloadFile_m0 = function(userId, ser_no, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            ser_no: ser_no,
            filename: filename
        }
    }
    return body
}


// 下載國壽保險業履行個人資料保護法告知義務內容
export const downloadPersonalInformationProtection = function(userId, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            filename: filename
        }
    }
    return body
}

// 下載國泰人壽回饋分享金試算表
export const downloadValueAddedBonusIllustration = function(userId, dataJsonStr) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            dataJsonStr: dataJsonStr
        }
    }
    return body
}

// 寄送邀請函(EMAIL)
export const invitation_SendEmail = function(userId, data, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            data: data,
            type: type,
        }
    }
    return body
}

// 寄送邀請函(簡訊)
export const invitation_SendMSG = function(userId, data) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            data: data
        }
    }
    return body
}

// 下載服務件調撥操作手冊(經理版  課長/組訓/區處主管版)
export const downloadFile_b1 = function(userId, ser_no, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            ser_no: ser_no,
            filename: filename,
        }
    }
    return body
}

//刪除條件篩選的查詢紀錄
export const deleteSearchFilterRecord = function(userId, record) {
    let bodyContent = {};
    if (record) {
        record['delete_type'] = '1'
        bodyContent = record
    } else {
        bodyContent['delete_type'] = '2'
        bodyContent['agnt_id'] = userId
    }

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: bodyContent
    }
    return body
}

// 查詢排訪Log
export const queryVisitEventLog = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "c",
            conditions: {
                crm: {
                    agnt_id: userId
                }
            }
        }
    }
    return body
}

// 查詢排訪
export const queryVisitEvent = function(userId, serNo, year) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "2",
            conditions: {
                box: {
                    event_ser_no: serNo,
                    event_year: year,
                    agidno: userId
                }
            }
        }
    }
    return body
}

// 查詢已安排排訪
export const queryBookedVisitEvent = function(userId, CsidData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "5",
            conditions: {
                box: {
                    agidno: userId,
                    csidnos: CsidData
                }
            }
        }
    }
    return body
}

// 列印申請書
export const getFamilyPrint = function(custData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: {
            cust: {
                idno: custData.idno,
                name: custData.name,
                mobile: custData.mobile,
                email: custData.email,
                applyNo: custData.applyNo
            }
        }
    }
    return body
}

// 列印KYC聲明書
export const getKYCPrint = function(userId,currentDate,kyc_lvl_name,custId,print_type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: {
            aply_date: currentDate,
            kyc_lvl_name: kyc_lvl_name,
            apc_id: custId,
            print_type: print_type
        }
    }
    return body
}

// 新增排訪
export const insertVisitEvent = function(userId, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "1",
            conditions: {
                box: reportData
            }
        }
    }
    return body
}

// 編輯排訪
export const updateVisitEvent = function(userId, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "3",
            conditions: {
                box: reportData
            }
        }
    }
    return body
}

// 刪除排訪
export const deleteVisitEvent = function(userId, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "4",
            conditions: {
                box: reportData
            }
        }
    }
    return body
}

// 名單專區寫入log
export const setListAreaLog = function(userId, ser_no, action_item, cust_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agentid: userId,
            ser_no: ser_no,
            action_item: action_item,
            cust_id: cust_id,
        }
    }
    return body
}

// 查詢名單專區公版名單清單
export const getCustomerSurveyData = function(userId, ser_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId,
            ser_no: ser_no,
        }
    }
    return body
}

// 建議書客戶寫入生日與性別
export const recommandInserSexAndBir = function(userId, custList) {
    let custListBody = {
        agnt_id: userId,
        csid: '',
        data: {},
        info: {},
    }
    let submitCustList = custList.map(item => {
        let data = {...custListBody }
        data.info = {
            birthday: item.birthday,
            id: item.csid.includes('~') ? '' : item.csid,
            name: item.name,
            ser_no: item.csid.includes('~') ? item.csid : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.csid.includes('~') ? '' : item.csid
        return data
    })

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                upd: {
                    upd_id: userId,
                    upd_source: "1"
                },
                custList: submitCustList
            }
        }
    }
    return body
}

// 計算保險年齡
export const computeAge = function(userId, birthday) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            birthday: birthday,
        }
    }
    return body
}

// 查詢業務員與客戶關係
export const queryRelationship = function(userId, agId, custId, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: agId,
                id: custId,
                api_id: api_id
            },
        },
    }
    return body
}

// 查詢業務員與客戶關係以保單號碼查詢
export const queryRelationshipByPolicyNo = function(userId, policyNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                policy_no: policyNo
            },
        },
    }
    return body
}

// 查詢服務件調撥原因
export const queryTransferReasonByConditions = function(userId, conditions) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                conditions: conditions
            },
        },
    }
    return body
}

// 名單專區_滿期目標客戶
export const getFullTargetCustom = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
            }
        }
    }
    return body
}

// 名單專區_年金目標客戶
export const getAnnuityTargetCustom = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
            }
        }
    }
    return body
}

// 名單專區_客戶資料校正專案
export const getInfoAdjustment = function(userId, asc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                asc: asc
            }
        }
    }
    return body
}

// 名單專區_停效關懷專案
export const getSuspensionCare = function(userId, asc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                asc: asc
            }
        }
    }
    return body
}

// 更新客戶資料校正專案已拜訪原因
export const updateVisit = function(userId, divNo, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            userId: userId,
            report: reportData,
            type: "Visit",
            divNo: divNo
        }
    }
    return body
}

// 更新客戶資料校正專案未拜訪原因
export const updateUnVisit = function(userId, divNo, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            userId: userId,
            report: reportData,
            type: "NonVisit",
            divNo: divNo
        }
    }
    return body
}

// 更新該cust停效關懷專案拜訪結果
export const updateVisitResult = function(userId, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            userId: userId,
            report: reportData,
        }
    }
    return body
}

//取得該cust滿期保單資訊
export const queryCustFullInfo = function(userId, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                agnt_id: userId,
                csid: csid,
            }
        }
    }
    return body
}

// 更新保戶滿期保單未拜訪原因
export const updateNonVisitReason = function(userId, reportData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: reportData
        }
    }
    return body
}

//更新該cust滿期保單聯繫單最新列印日期
export const updatePrintDate = function(userId, plc, csid) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                plc: plc,
                csid: csid,
                agnt_id: userId,
            }
        }
    }
    return body
}

//取得該滿期保單詳細資訊
export const getFullPlcInfo = function(userId, plc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                plc: plc,
            }
        }
    }
    return body
}

//列印滿期保單聯繫單
export const showFullPlcPDF = function(userId, plc, ceempnm) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                plc,
                ceempnm
            }
        }
    }
    return body
}

// 整合行銷-車/火險預約單
export const getCarFireInsuranceReserve = function(userId, agId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: agId,
            },
        },
    }
    return body
}

// 整合行銷-車險預約單
export const getCarInsuranceReserve = function(userId, agId, custId, caseno, seqno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: agId,
                customer_id: custId,
                case_no: caseno,
                seq_no: seqno
            },
        },
    }
    return body
}

// 整合行銷-火險預約單
export const getFireInsuranceReserve = function(userId, agId, custId, caseno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: agId,
                customer_id: custId,
                case_no: caseno,
            },
        },
    }
    return body
}

// 整合行銷-車險未續保名單
export const getCarInsuranceUnRenewed = function(userId, agId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: agId,
            },
        },
    }
    return body
}

// 重新歸戶家戶之成員
export const reclassifyFamilyMembers = function(userId, reclassifyData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                Type: "reclassify",
                Agent: userId,
                Value: reclassifyData,
            }
        }
    }
    return body
}

// 下載異動後實質接觸追蹤表
export const downloadChangeTrace = function(userId, api_id, is_vip, start_date, end_date, group) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: api_id,
                is_vip: is_vip,
                start_date: start_date,
                end_date: end_date,
                group: group
            }
        }
    }
    return body
}


// 查詢強制調撥總表
export const dowlnloadMandatoryAllocationSummary = function(userId, api_id, no_estrange, intime, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: api_id,
            no_estrange: no_estrange,
            intime: intime,
            report: {
                qs: report.startDate,
                qe: report.endDate,
                ceadcd: report.ceadcd,
                monthChk: report.monthChk
            }
        }
    }
    return body
}

// 是否至國泰學習網完成調訓課程
export const checkFinishClass = function(userId, classId, userCategoryId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                userId: userId,
                classId: classId,
                userCategoryId: userCategoryId
            }
        }
    }
    return body
}

// 取得退休人員
export const queryCeclcList = function(userId, divNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                divNo: divNo
            }
        }
    }
    return body
}

// 更新退休人員
export const updateCeclcList = function(userId, is_back, selectedList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                is_back: is_back,
                selectedList: selectedList
            }
        }
    }
    return body
}

// 取得單位地址座標
export const queryDivLatLnt = function(userId, divNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                divNo: divNo
            }
        }
    }
    return body
}

// 取得首頁宣傳圖檔資訊
export const queryIndexPopUp = function(agnt_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agnt_id
        },
        body: {
            report: {
                agnt_id: agnt_id
            }
        }
    }
    return body
}

// 寫入首頁宣傳圖檔使用者確認
export const insertPopUp = function(agnt_id, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: agnt_id
        },
        body: {
            report: {
                agnt_id: agnt_id,
                type: type
            }
        }
    }
    return body
}

// 活動推廣-企業客戶申辦官網會員名單
export const getCustomerApplyForMember = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                agnt_id: userId // 業務員ID
            }
        }
    }
    return body
}

// 數位獎勵推動
export const getIonlyU = function(userId, asc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                api_id: '1',
                agnt_id: userId, // 業務員ID
                asc: asc
            }
        }
    }
    return body
}

// 數位獎勵推動(bycsid)
export const getIonlyU_csid = function(userId, custids) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                api_id: '2',
                agnt_id: userId, // 業務員ID
                custIDList: custids
            }
        }
    }
    return body
}

//  查詢今天已發送名單
export const getSended = function(userId, custids, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                type: type,
                agnt_id: userId, // 業務員ID
                custIDList: custids
            }
        }
    }
    return body
}

// 試打API
export const getIonlyU_API = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            csid: userId, // 業務員ID
        }
    }
    return body
}

// 查詢心安逸將滿期名單
export const getMindWithJoy = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 查詢高階白領企業福利家
export const getHighClassWhiteCollar = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 查詢相同標籤的客戶
export const getSameTagCust = function(userId, tagId, csId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                tag_id: tagId,
                cs_id: csId
            }
        }
    }
    return body
}

// 查詢所有客戶標籤
export const getAllCustTag = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {}
    }
    return body
}

// 新增客戶標籤點擊留存log紀錄
export const addCustTagLog = function(userId, logData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            logData: logData
        }
    };
    return body;
}

// 查詢未申辦 「FitBack健康吧」
export const getCWPList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 查詢未申辦 「FitBack健康吧」
export const getSincereGuard = function(userId, asc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                asc: asc
            }
        }
    }
    return body
}

// 查詢所有商品類別
export const getAllProdType = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 修改私人筆記
export const updatePersonalNote = function(userId, csId, note_date, note_time, note_string) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                csid: csId,
                note_date: note_date,
                note_time: note_time,
                note_string: note_string
            }
        }
    }
    return body
}

// 查詢傷害險調整提高保額
export const getInjuryList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

//取得提醒事項
export const getAttention = function(userId, agnt_id, csid, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id, // 6:取得提醒事項資料
            customer: {
                agnt_id: agnt_id,
                id: csid
            }
        }
    }
    return body
}

//取得高齡關懷包連結
export const getEldSolicitudeUrl = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    }
    return body
}

//新增高齡關懷包Log
export const insertEldSolicitudeLog = function(userId, csid, kind) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            userId: userId,
            csid: csid,
            kind: kind
        }
    }
    return body
}

// 查詢網路服務推動名單
export const getWebServicePushList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId
            }
        }
    }
    return body
}

// 後台管理_名單管理
export const callCategoryProcess = function(userId, api_id, categoryData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                api_id: api_id,
                categoryData: categoryData
            }
        }
    }
    return body
}

// 後台管理_名單管理_附件上傳
export const callFileUpload = function(userId, api_id, file, ser_no) {
    let form = new FormData()
    form.append("file", file, file.name)

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            report: {
                api_id: api_id,
                ser_no: ser_no
            }
        }
    }
    form.append("json", JSON.stringify(body))
    return form
}

// 後台管理_名單管理_附件刪除
export const callFileDelete = function(userId, api_id, ser_no, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: api_id,
            ser_no: ser_no,
            filename: filename
        }
    }
    return body
}

// 單位佈告欄-新增訊息
export const callBullentinProcess = function(userId, bullentinData, api_id, file = '') {
    let form = new FormData()
    if (file !== '') {
        form.append("file", file, file.name)
    }
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: bullentinData,
            api_id: api_id
        }
    }
    form.append("json", JSON.stringify(body))

    return form
}

// 後台管理_彈跳式廣告新增
export const addPopupData = function(userId, popupData, file) {
    let form = new FormData()
    form.append("userId", userId)
    form.append("file", file, file.name)
    form.append("mod_id", popupData.mod_id)
    form.append("start_date", popupData.start_date)
    form.append("end_date", popupData.end_date)
    form.append("photo_desc", popupData.photo_desc)
    form.append("approval_status", popupData.approval_status)
    form.append("input_id", popupData.input_id)
    form.append("input_nm", popupData.input_nm)
    form.append("reconfirm", popupData.reconfirm)
    form.append("fileIsChanged", popupData.fileIsChanged)
    return form
}

// 後台管理_彈跳式廣告修改
export const updatePopupData = function(userId, popupData, file) {
    let form = new FormData()
    if (file !== '') {
        form.append("file", file, file.name)
    }
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: popupData
        }
    }
    form.append("json", JSON.stringify(body))
    return form
}

// 後台管理_彈跳式廣告管理查詢
export const callPopupProcess = function(userId, popupData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: popupData
        }
    }
    return body
}

// 後台管理_彈跳式廣告取消申請
export const deletePopupData = function(userId, popupData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: popupData

        }
    }
    return body
}

// 查詢團險Keyman
export const getGroupInsuranceKeyMan = function(userId, order) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                order: order
            }
        }
    }
    return body
}

// 首頁_新增近期動態點擊log
export const addIndexDynamicLog = function(userId, logData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            logData: logData
        }
    };
    return body;
}

// 查詢醫療有約
export const getMedicalEDM = function(userId, order) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                order: order
            }
        }
    }
    return body
}

// 後台管理_客戶ID異動資料查詢
export const queryCustomerIdData = function(userId, queryMap, order) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                queryMap: queryMap,
                order: order,
                api_id: "1"
            }
        }
    }
    return body
}

// 後台管理_客戶ID異動資料新增
export const addCustomerIdData = function(userId, insertMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                insertMap: insertMap,
                api_id: "2"
            }
        }
    }
    return body
}

// 後台管理_電話編輯檢視
export const queryEditRecord = function(queryMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id,
        },
        body: {
            conditions: {
                queryMap: queryMap,
                api_id: "1"
            }
        }
    }
    return body
}

// 後台管理_電話異動查詢
export const queryCustTel = function(queryMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id,
        },
        body: {
            conditions: {
                queryMap: queryMap,
                api_id: "2"
            }
        }
    }
    return body
}

// 後台管理_電話異動
export const updateCustTel = function(updateMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id,
        },
        body: {
            conditions: {
                updateMap: updateMap,
                api_id: "3"
            }
        }
    }
    return body
}

// 後台管理_客戶資料檢視權限查詢
export const queryCustDataViewPermission = function(userId, queryMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                queryMap: queryMap,
                api_id: "1"
            }
        }
    }
    return body
}

// 後台管理_客戶資料檢視權限新增
export const addCustDataViewPermission = function(userId, insertMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                insertMap: insertMap,
                api_id: "2"
            }
        }
    }
    return body
}

// 後台管理_客戶資料檢視權限解除
export const delCustDataViewPermission = function(userId, deleteMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                deleteMap: deleteMap,
                api_id: "3"
            }
        }
    }
    return body
}

// 查詢未訪件業務員清單
export const queryUnvisitedList = function(userId, ceclcno) {
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "queryUnvisitedList",
            ceclcno: ceclcno
        }
    }
    return reqBody
}

// 覆核排除未訪件
export const approveUnvisitedList = function(userId, cedvno3, dataList) {
    let approveData = dataList.map(eachObj => {
        eachObj['mgr_id'] = userId;
        eachObj['cedvno3'] = cedvno3;
        eachObj['exclude'] = 1;
        return eachObj
    })
    let reqBody = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            api_id: "approveUnvisitedList",
            approve_list: approveData
        }
    }
    return reqBody
}

// 取得客戶標籤名稱
export const queryTagName = function(userId, tag_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "1",
                tag_id: tag_id
            }
        }
    }
    return body
}

// 更新客戶標籤定義和排序
export const updateDefAndSort = function(userId, defMap, sortMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "2",
                defMap: defMap,
                sortMap: sortMap
            }
        }
    }
    return body
}

// 異動客戶標籤資料
export const editCustTag = function(userId, tag_id, tagData, api_id, picfile = '', file1 = '', file2 = '', file3 = '') {
    let form = new FormData()
    if (picfile !== '') {
        form.append("picfile", picfile, picfile.name)
    }
    if (file1 !== '') {
        form.append("file1", file1, file1.name)
    }
    if (file2 !== '') {
        form.append("file2", file2, file2.name)
    }
    if (file3 !== '') {
        form.append("file3", file3, file3.name)
    }
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: api_id,
                tag_id: tag_id,
                tagData: tagData
            }
        }
    }
    form.append("json", JSON.stringify(body))

    return form
}

// 下載客戶標籤參考資料
export const downloadTagFile = function(userId, tag_id, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            tag_id: tag_id,
            filename: filename,
        }
    }
    return body
}

// 查詢所有客戶標籤和定義
export const queryAllTagAndDef = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                api_id: "4"
            }
        }
    }
    return body
}

// 查詢資料(只傳入業務員ID)
export const getDataByAgid = function(userId, custHasFamily = 'Y') {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                cust_has_family: custHasFamily
            }
        }
    }
    return body
}

// 查詢資料(業務員ID使用後端的userObj)，request不傳userId
export const getDataByCurrentAgid = function(custHasFamily = 'Y') {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            conditions: {
                cust_has_family: custHasFamily
            }
        }
    }
    return body
}

// 查詢事件偵測_人資神助攻名單
export const queryEventDetectionHR = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 查詢FitBack愛好者名單
export const getFitbackLoverList = function(userId, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                ser_no: serNo
            }
        }
    }
    return body
}

// 取得分享活動連結文字(欄位不可用table_name會被F5擋掉)
export const getShareLinkText = function(userId ,tab_name = "DTMXM720",field_name="SHARE_TEXT", sysid="MX" ) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            DTMXS000: {
                tab_name: tab_name,
                field_name: field_name,
                sysid: sysid
            }
        }
    }
    return body
}


// 身故關懷名單_保戶身故狀況回報
export const doDieCheck = function(userId, csid, birthday, visit_reply, visit_way, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                csid: csid,
                birthday: birthday,
                visit_reply: visit_reply,
                visit_way: visit_way,
                type: type
            }
        }
    }
    return body
}

// 身故關懷名單_未辦理原因回報
export const doReplyCauseCheck = function(userId, csid, birthday, clcno, reply_cause, reply_memo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                csid: csid,
                birthday: birthday,
                clcno: clcno,
                reply_cause: reply_cause,
                reply_memo: reply_memo
            }
        }
    }
    return body
}

// 合併拜訪記錄
export const mergeVisit = function(userId, csid, csid_new, csname) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                csid: csid,
                csid_new: csid_new,
                csname: csname
            }
        }
    }
    return body
}

// 未滿15足歲保障缺口名單_回報
export const doInformReply = function(userId, ser_no, inform_result, inform_remark) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                ser_no: ser_no,
                inform_result: inform_result,
                inform_remark: inform_remark
            }
        }
    }
    return body
}

// 提醒事項_外溢保單資訊查詢
export const getSpilloverInfo = function(userId, list) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                list: list
            }
        }
    }
    return body
}

// 查詢寄送資格/訊息發送狀態
export const getSendResult = function(userId, csid, api_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                csid: csid,
                api_id: api_id
            }
        }
    }
    return body
}

// 寄發簡訊/Email
export const doSendAPI = function(userId, data) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                data: data
            }
        }
    }
    return body
}

// 60周年全面拜訪名單_無法拜訪客戶回報
export const doReply60AnniversaryList = function(userId, dataMap) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            dataMap: dataMap
        }
    }
    return body
}

// 60周年全面拜訪名單_依客戶姓名排序(筆劃)
export const doSort60AnniversaryList = function(userId, order, list) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                order: order,
                list: list
            }
        }
    }
    return body
}

// 客戶保單_依被保人姓名排序(筆畫)
export const doSortFullnameList = function(userId, order, col, list) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                order: order,
                col: col,
                list: list  
            }
        }
    }
    return body
}

// 查詢外溢保單 (保單資訊頁面)
export const getSpilloverPolicyData = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                policy_no: policy_no
            }
        }
    }
    return body
}

// 保代用查詢外溢保單 (保單資訊頁面)
export const getSpilloverPolicyForBnk = function(userId, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id: userId,
                policy_no: policy_no
            }
        }
    }
    return body
}

// 取消失聯
export const cancelMissingLost = function(userId, visit_no_list) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agid: userId,
                api_id: "4"
            },
            visit_no_list : visit_no_list
        }
    }
    return body
}

// 依客戶姓名排序(筆劃)
export const doSortListByName = function(userId, order, list) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                order: order,
                list: list
            }
        }
    }
    return body
}

// 依傳入欄位排序(筆劃)
export const doSortList = function(order, list, col) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP
        },
        body: {
            conditions: {
                order: order,
                list: list,
                col: col
            }
        }
    }
    return body
}

// 收費轉型關懷名單_回報排訪結果
export const doVisitReply = function(userId, policy_no, chk_status, pay_way_code) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            conditions: {
                agnt_id : userId,
                policy_no: policy_no,
                chk_status: chk_status,
                pay_way_code: pay_way_code
            }
        }
    }
    return body
}


// 取得泰好客未拜訪問卷網址
export const getSurveyUrl = function(userId, csid, ser_no, subsystem) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            id: csid,
            ser_no: ser_no,
            subsystem: subsystem
        }
    }
    return body
}

// 更新問卷紀錄
export const updateSurveyRecord = function(userId, quest_no, spot_ser_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agnt_id: userId,
            quest_no: quest_no,
            spot_ser_no: spot_ser_no
        }
    }
    return body
}

// 查詢國泰產險-旅綜險-被保人名冊
export const getCustInsurance_CCIPLN3_detail = function(userId, csid, policy_no) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            csid: csid,
            policy_no: policy_no
        }
    }
    return body
}

//-------------------------------------------------------------保單健檢-------------------------------------------------------------
//用業務員ID搜尋戶長
export const getAllHouseholderBySales = function(userId, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: userId
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//姓名、身分證、保單號碼搜尋家戶
export const getFamilyMemberBycondition = function(userId, conditions) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: userId,
            conditions: {
                input: conditions,
                cs_source1: '1',
                cs_source2: '1',
                cs_source3: '1',
                cs_source4: '1',
                cs_source5: '1',
                cs_source6: '1',
                order_by: '3',
                order_asc: '1',
            }
        }
    }
    return body
}

//保代用姓名、身分證、保單號碼搜尋家戶
export const getFamilyMemberByConditionBnk = function(userId, conditions) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            conditions: conditions
        }
    }
    return body
}

//業務員ID&&戶長ID取得家庭成員資料
export const getAllFamily = function(userId, csidno, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: userId,
            FAMILYID: csidno
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//列印PDF(藏保圖)
export const getPDFFile = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//列印PDF(藏保圖)ForMail
export const getPDFFileForMail = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//列印PDF(家庭保單健檢規劃書))
export const getFamilyCheckPDFFile = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//列印PDF(家庭保單健檢規劃書)ForMail
export const getFamilyCheckPDFFileForMail = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//取得客服中心報表列印資料
export const getServiceCenterData = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//PDF(家庭保單健檢規劃書)(取得檔案)
export const getFamilyCheckPDFFileByFileNo = function(userId, fileNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: { fileNo: fileNo }
    }
    return body
}

//查詢常用報表
export const getCommonlyUsedReport = function(userId, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agentId: userId,
            report: report
        }
    }
    return body
}

//新增常用報表
export const insertCommonlyUsedReport = function(userId, report, reportType) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agentId: userId,
            report: report,
            reportType: reportType
        }
    }
    return body
}

//刪除常用報表
export const deleteCommonlyUsedReport = function(userId, report, reportType) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agentId: userId,
            report: report,
            reportType: reportType
        }
    }
    return body
}

//取得保單資訊
export const getContractContent = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    return body
}

// 取得客戶列表
export const queryRelationList = function(
    userId,
    input, s1 = '1', s2 = '1', s3 = '1', s4 = '1', s5 = '1', s6 = '1', order_by = '2', order_asc = '1'
) {
    console.log("store.state.userIP: ", store.state.userIP);
    console.log("userId : ", userId);
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                input: input ? input : "",
                cs_source1: s1,
                cs_source2: s2,
                cs_source3: s3,
                cs_source4: s4,
                cs_source5: s5,
                cs_source6: s6,
                order_by: order_by,
                order_asc: order_asc
            }
        }
    };
    return body;
};

// 取得相關保單資訊
export const queryPolicyList = function(
    userId, cust_id, order_by, order_asc
) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                order_by: order_by,
                order_asc: order_asc
            },
            cust_id: cust_id
        }
    };
    return body;
};

export const queryPolicyRelateList = function(userId, data, order_by = '2', order_asc = '1') {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                order_by: order_by,
                order_asc: order_asc
            },
            id_list: data
        }
    };
    return body;
};

export const insertCustInFamilyBnk = function(userId, insertData, idList) {
    const submitCustList = insertData.map(el => {
        return {
            Name: el.name,
            PersonalId: el.csidno,
            Sex: el.sex,
            age: el.age,
            Birthday: el.birthday,
            agidno: el.agidno,
            familyid: el.familyid,
            familyrl: el.familyrl
        };
    });

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: submitCustList,
            id_list: idList,
            source:"BNK"
        }
    };
    return body;
};

export const insertCustInFamily = function(userId, insertData, idList, hasSpouse, trn_cd) {
    const submitCustList = insertData.map(el => {
        return {
            Name: el.name,
            PersonalId: el.csidno,
            Sex: el.sex,
            age: el.age,
            Birthday: el.birthday || "9999-12-31",
            agidno: el.agidno,
            familyid: el.familyid,
            familyrl: el.familyrl
        };
    });

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                Agent: userId,
                upd_source: "5",
                Value: submitCustList,
                trn_cd: trn_cd
            },
            id_list: idList,
            hasSpouse: hasSpouse
        }
    };
    return body;
};
export const updateCustInFamily = function(userId, insertData) {
    let custListBody = {
        agnt_id: userId,
        csid: "",
        data: {},
        info: {}
    };

    let submitCustList = insertData.map(item => {
        let data = {...custListBody };
        data.info = {
            birthday: item.birthday,
            id: item.csidno.includes("~") ? "" : item.csidno,
            name: item.name,
            ser_no: item.csidno.includes("~") ? item.csidno : "",
            sex: item.sex,
            age: item.age
        };
        data.csid = item.csidno.includes("~") ? "" : item.csidno;
        return data;
    });

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                upd: {
                    upd_id: userId,
                    upd_source: "5" //from保單健檢
                },
                custList: submitCustList
            },
            reqList: insertData
        }
    };
    return body;
};

// 修改家戶資料
export const modifyFamilyMember = function(userId, custList, checkDeleteCount, checkOnlyId) {
    let custListBody = {
        agnt_id: userId,
        csid: '',
        data: {},
        info: {},
        customer: {}
    }
    let submitCustList = custList.map(item => {
        let data = {...custListBody }
        data.info = {
            birthday: item.birthday && item.birthdayROC ? item.birthday : '',
            id: item.csidno.includes('~') ? '' : item.csidno,
            name: item.name,
            ser_no: item.serNo ? item.serNo : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.serNo ? '' : item.csidno
        if (!item.csidno || item.csidno == '') {
            item.csidno = item.serNo
        }
        return data
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                upd: {
                    upd_id: userId,
                    upd_source: "5"
                },
                custList: submitCustList
            },
            reqList: custList,
            checkDelete: checkDeleteCount > 0 ? true : false, //是否有刪除件
            checkOnlyId: checkOnlyId //是否為輸入ID
        }
    }
    return body
}


// 修改家戶資料(保代)
export const modifyFamilyMember_BNK = function(userId, custList,checkRemoveCount, checkDeleteCount, checkOnlyId) {
    let custListBody = {
        agnt_id: userId,
        csid: '',
        data: {},
        info: {},
        customer: {}
    }
    let submitCustList = custList.map(item => {
        let data = {...custListBody }
        data.info = {
            birthday: item.birthday && item.birthdayROC ? item.birthday : '',
            id: item.csidno.includes('~') ? '' : item.csidno,
            name: item.name,
            ser_no: item.serNo ? item.serNo : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.serNo ? '' : item.csidno
        if (!item.csidno || item.csidno == '') {
            item.csidno = item.serNo
        }
        return data
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: {
                upd: {
                    upd_id: userId,
                    upd_source: "5"
                },
                custList: submitCustList
            },
            reqList: custList,
            checkRemove: checkRemoveCount > 0 ? true : false, //是否有移除家戶成員
            checkDelete: checkDeleteCount > 0 ? true : false, //是否有刪除客戶
            checkOnlyId: checkOnlyId //是否為輸入ID
        }
    }
    return body
}

//確認家戶成員是否有保單
export const checkPolicyExist = function(userId, csList, familyId, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: userId,
            CSIDNOLIST: csList,
            FAMILYID: familyId
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//確認家戶成員是否有保單
export const isCustomerAgreeRemind = function(userId, familyId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: userId,
            FAMILYID: familyId
        }
    }
    return body
}

//刪除所有家戶
export const deleteFamily = function(userId, csList, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            csList: csList
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//取得國壽壽險保單資訊
export const getCathayInsurance = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    
    return body
}
//取得同業、建議書保單資訊
export const getOtherInsurance = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    
    return body
}

//取得國壽壽險保單資訊（要保人視角）
export const getCathayInsuranceApplicant = function(userId, sendData) {
  let body = {
    header: {
      userDeviceIp: store.state.userIP,
      userId: userId
    },
    body: {
      CSLIST: sendData,
      ISAPC: "Y"
    }
  }
  return body
}

//取得同業、建議書保單資訊（要保人視角）
export const getOtherInsuranceApplicant = function(userId, sendData) {
  let body = {
    header: {
      userDeviceIp: store.state.userIP,
      userId: userId
    },
    body: {
      CSLIST: sendData,
      APC: "Y"
    }
  }
  return body
}

//取得同業、建議書保單資訊ForMX
export const getOtherInsuranceForMX = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData,
            APC: "Y"
        }
    }
    return body
}
//取得團險保單資訊
export const getGroupInsurance = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    return body
}

//取得國壽產險保單資訊
export const getCathayPropertyInsurance = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    return body
}

//取得同業產險保單資訊
export const getOtherPropertyInsurance = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//取得同業產險保單資訊
export const getPropertyInsurance = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//取得同業產險保單資訊
export const ckeckPropertyInsuranceCustomers = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSLIST: sendData
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//以單一家庭成員ID查詢戶長
export const getFamilyMemberByCsidNo = function(userId, sendData, isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CSIDNO: sendData,
            AGIDNO: userId
        }
    }

    if (isFromBank) {
      body.body.source = "BNK"  
    }
    return body
}

//取得業務員列印用聯絡資訊
export const getAgntInfo = function(userId, agnt_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: agnt_id
        }
    }
    return body
}

//取得業務員列印用聯絡資訊
export const updateAgntInfo = function(userId, updateData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reqList: updateData
        }
    }
    return body
}

//將選中家戶成員加入現有家戶
export const addMembersToFamily = function(userId, newFamilyId, addFamilyMembers, isFromBank) {

    let originalFamily
    let mxAddFamilyMembers = addFamilyMembers.map(item => {
        let custListBody = {
            agnt_id: userId,
            csid: '',
            data: {},
            info: {},
            customer: {}
        }
        let data = {...custListBody }
        originalFamily = item.familyid
        data.info = {
            birthday: item.birthday ? item.birthday : '',
            id: item.csidno.includes('~') ? '' : item.csidno,
            name: item.name,
            ser_no: item.csidno.includes('~') ? item.csidno : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.csidno.includes('~') ? '' : item.csidno
        return data
    })


    addFamilyMembers = addFamilyMembers.map(item => {
        let custListBody = {
            agnt_id: userId,
            csid: '',
            data: {},
            info: {},
            customer: {}
        }
        let data = {...custListBody }
        data = {
            familyrl: item.familyrl,
            name: item.name,
            sex: item.sex,
            birthday: item.birthday && item.birthdayROC ? item.birthday : '',
            csidno: item.csidno,
            age: item.age
        }
        return data
    })

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            newFamilyId: newFamilyId,
            originalFamily: originalFamily,
            addFamilyMembers: addFamilyMembers,
            mxAddFamilyMembers: {
                report: {
                    upd: {
                        upd_id: userId,
                        upd_source: "5"
                    },
                    custList: mxAddFamilyMembers
                }
            }
        }
    }

    if (isFromBank) {
        body.body.source = "BNK"  
    }
    return body
}
//更換原家戶戶長
export const changeFamilyLeader = function(userId, lastFamilyResult, newFamilyId, addFamilyMembers, isFromBank) {
    let custListBody = {
        agnt_id: userId,
        csid: '',
        data: {},
        info: {},
        customer: {}
    }
    let mxAddFamilyMembers = addFamilyMembers.map(item => {
        let data = {...custListBody }
        data.info = {
            birthday: item.birthday ? item.birthday : '',
            id: item.csidno.includes('~') ? '' : item.csidno,
            name: item.name,
            ser_no: item.csidno.includes('~') ? item.csidno : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.csidno.includes('~') ? '' : item.csidno
        return data
    })

    let mxLastFamilyResult = lastFamilyResult.map(item => {
            let data = {...custListBody }
            data.info = {
                birthday: item.birthday,
                id: item.csidno.includes('~') ? '' : item.csidno,
                name: item.name,
                ser_no: item.csidno.includes('~') ? item.csidno : '',
                sex: item.sex,
                age: item.age
            }
            data.csid = item.csidno.includes('~') ? '' : item.csidno
            return data
        })
        //---------------------------------------------------
    let originalFamily = ''
    addFamilyMembers = addFamilyMembers.map(item => {
        let data = {
            familyrl: item.familyrl,
            name: item.name,
            sex: item.sex,
            birthday: item.birthday,
            csidno: item.csidno,
            age: item.age,
            familyid: newFamilyId
        }
        return data
    })
    lastFamilyResult = lastFamilyResult.map(item => {
            if (item.familyrl == 0) {
                originalFamily = item.csidno
            }
            let data = {
                familyrl: item.familyrl,
                name: item.name,
                sex: item.sex,
                birthday: item.birthday,
                csidno: item.csidno,
                age: item.age,
                familyid: item.familyid
            }
            return data
        })
        //----------------------------------------------------
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            newFamilyId: newFamilyId,
            originalFamily: originalFamily,
            addFamilyMembers: addFamilyMembers,
            lastFamilyResult: lastFamilyResult,
            lastFamilyId: lastFamilyResult[0].familyid,
            mxLastFamilyResult: {
                report: {
                    upd: {
                        upd_id: userId,
                        upd_source: "5"
                    },
                    custList: mxLastFamilyResult
                }
            },
            mxAddFamilyMembers: {
                report: {
                    upd: {
                        upd_id: userId,
                        upd_source: "5"
                    },
                    custList: mxAddFamilyMembers
                }
            },
        }
    }

    if (isFromBank) {
      body.body.source = "BNK"  
    }
    return body
}

//成立新的家戶
export const createNewFamily = function(userId, newFamilyId, addFamilyMembers) {

    let mxAddFamilyMembers = addFamilyMembers.map(item => {
        let custListBody = {
            agnt_id: userId,
            csid: '',
            data: {},
            info: {},
            customer: {}
        }
        let data = {...custListBody }
        data.info = {
            birthday: item.birthday ? item.birthday : '',
            id: item.csidno.includes('~') ? '' : item.csidno,
            name: item.name,
            ser_no: item.csidno.includes('~') ? item.csidno : '',
            sex: item.sex,
            age: item.age
        }
        data.csid = item.csidno.includes('~') ? '' : item.csidno
        return data
    })


    addFamilyMembers = addFamilyMembers.map(item => {
        let custListBody = {
            agnt_id: userId,
            csid: '',
            data: {},
            info: {},
            customer: {}
        }
        let data = {...custListBody }
        data = {
            familyrl: item.familyrl,
            name: item.name,
            sex: item.sex,
            birthday: item.birthday && item.birthdayROC ? item.birthday : '',
            csidno: item.csidno,
            age: item.age
        }
        return data
    })

    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            newFamilyId: newFamilyId,
            addFamilyMembers: addFamilyMembers,
            mxAddFamilyMembers: {
                report: {
                    upd: {
                        upd_id: userId,
                        upd_source: "5"
                    },
                    custList: mxAddFamilyMembers
                }
            }
        }
    }
    return body
}

//新增同仁眷屬
export const addAGFamily = function(userId, insertData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: insertData
    }
    return body
}

//刪除同仁眷屬
export const deleteAGFamily = function(userId, deleteData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: deleteData
    }
    return body
}

//搜尋是否有此業務員
export const checkAGExist = function(userId, selectData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: selectData
    }
    return body
}

//查詢業務員資料
export const selectAGData = function(userId, selectData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: selectData
    }
    return body
}

//查詢業務員已刪除資料
export const selectAGDeleteData = function(userId, selectDeleteData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: selectDeleteData
    }
    return body
}

//取得業務員列印用聯絡資訊
export const getPdfFileForReport = function(userId, filename) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            filename: filename
        }
    }
    return body
}


//新增國泰產險被保人姓名難字設定檔
export const insertDiffWord = function(userId, insertData, policyList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            insertData: insertData,
            policyList: policyList
        }
    }
    return body
}

//更新國泰產險被保人姓名難字設定檔
export const updateDiffWord = function(userId, updateData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            updateData: updateData
        }
    }
    return body
}

//更新國泰產險被保人姓名難字設定檔
export const deleteDiffWord = function(userId, deleteData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            deleteData: deleteData
        }
    }
    return body
}

//更新單筆國泰產險被保人姓名難字設定檔
export const updateSingleDiffWord = function(userId, updateSingleData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            updateSingleData: updateSingleData
        }
    }
    return body
}

//查詢國泰產險被保人姓名難字設定檔
export const queryDiffWord = function(userId, queryData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            queryData: queryData
        }
    }
    return body
}

//取得產險公司下拉清單
export const getInsuranceCompanies = function(userId) {
    return {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    }
}

//取得產險公司合併清單合併清單
export const getMergeInsuranceCompanies = function(userId) {
    return {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    }
}

// create request body
export const createRequestBody = function(body) {
    return {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body
    }
}
//新增國泰產險
export const insertSelfInputPropertyNumber = function(userId, insurances) {
    let dataList = insurances.map(data => {
        return {
            plcno: data.policyNumber,
            pln: data.pln,
            agidno: userId
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            PolicyDataList: dataList
        }
    }
    return body
}

//查詢自行輸入國泰產壽保單
export const getQuerySelfInputPropertyNumber = function(userId, insuredID, policyNumber) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            insuredID: insuredID,
            policyNumber: policyNumber
        }
    }
    return body;
}

//查詢拒絕產險共同行銷紀錄
export const getRejectPropertyComarketing = function(userId, insuredID) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            id: insuredID
        }
    }
    return body;
}

//查詢自行輸入國泰產險保單
export const getExistsSelfInputProperty = function(userId, agent, nums) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: agent,
            plcnos: nums
        }
    }
    return body;
}

//查詢保單與客戶關係
export const getPolicyConsumerRelationship = function(userId, insuredID, policyNumber) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            id: insuredID,
            policy_no: policyNumber
        }
    }
    return body;
}

//取得公司別下拉清單
export const getCompanies = function(userId) {
    return {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    }
}

//取得險種下拉清單
export const getInsuranceTypes = function(userId, companyid, contracttype) {
    return { header: { userDeviceIp: store.state.userIP, userId: userId }, body: { companyid, contracttype } };
}

//新增自行輸入國泰壽險保單號碼
export const insertSelfInputPolicyNumber = function(userId, insurances) {
    let dataList = insurances.map(data => {
        return {
            plcno: data.policyNumber,
            agidno: userId
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            PolicyDataList: dataList
        }
    }
    return body
}

//取得年期
export const getAnnual = function(userId, productid) {
    return { header: { userDeviceIp: store.state.userIP, userId: userId }, body: { productid } };
};

//取得計畫別
export const getPlan = function(userId, productid) {
    return { header: { userDeviceIp: store.state.userIP, userId: userId }, body: { productid } };
};

//是否可以檢視自行輸入國壽保單
export const canViewCreateInsuranceMyself = function(userId, agent_id, id) {
    return { header: { userDeviceIp: store.state.userIP, userId: userId }, body: { agent_id, id } };
};

//查詢國壽主附約資料檔
export const getQueryPropertyNumber = function(userId, policyNumber) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            plcno: policyNumber
        }
    }
    return body;
}
//查詢主被保人國壽主附約資料檔
export const getQueryPlcnoIdno = function(userId, insuredID, policyNumber) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            idno: insuredID,
            plcno: policyNumber
        }
    }
    return body;
}


//查詢保障查詢-當年度保障查詢(保障總覽)API
export const getCurrentYearCoverageSummary = function(userId, familyId, CSLIST, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST,
            type: type
        }
    }
    return body
}

//查詢當年度保障
export const getCurrentYearCoverageDetail = function(userId, familyid, cslistAll, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            familyid: familyid,
            cslistAll: cslistAll,
            type: type
        }
    }
    return body;
}

//查詢基本醫療度保障
export const getMedicalCoverageDetail = function(userId, familyid, cslistAll, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            familyid: familyid,
            cslistAll: cslistAll,
            type: type
        }
    }
    return body;
}
//保障查詢-查詢細項
export const getCoverageDetail = function(userId, policyNumber, isPolicyId, cslistAll, isSelfInsert, checkApc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            isPolicyId: isPolicyId,
            cslistAll: cslistAll,
            policyNumber: policyNumber,
            isSelfInsert: isSelfInsert,
            checkApc: checkApc ? checkApc : false
        }
    }
    return body;
}


//查詢逐月保費
export const getPremiumTotalListDataSetDetail = function(userId, familyid, cslistAll, checkApc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            familyid: familyid,
            cslistAll: cslistAll,
            checkApc: checkApc
        }
    }
    return body;
}

//查詢保障查詢-逐年保費一覽表(保障總覽)API
export const getEachYearPremiunSummary = function(userId, familyId, CSLIST, checkApc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST,
            checkApc: checkApc
        }
    }
    return body
}

//查詢保障查詢-逐年保費一覽表(個人資料)API
export const getEachYearPremiunDetail = function(userId, familyId, CSLIST, checkApc) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST,
            checkApc: checkApc
        }
    }
    return body
}

//滿期金或年金領回(家戶總覽)API
export const getAnnuityCoverageSummary = function(userId, familyId, CSLIST) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST
        }
    }
    return body
}


//滿期金或年金領回(個人資料)API
export const getAnnuityCoverageDetail = function(userId, familyId, CSLIST) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST
        }
    }
    return body
}

//身故/失能逐年保障查詢(家戶總覽)API
export const getDeathCoverageSummary = function(userId, familyId, CSLIST) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST
        }
    }
    return body
}

//身故/失能逐年保障查詢(家戶總覽)API
export const getDeathCoverageDetail = function(userId, familyId, CSLIST) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST
        }
    }
    return body
}

//保障查詢-未來保障視圖API
export const getAllCoverageForView = function(userId, familyId, CSLIST, typeList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            familyId: familyId,
            CSLIST: CSLIST,
            coverageTypeList: typeList
        }
    }
    return body
}


// 查詢是否為家庭型保單
export const getQueryPlcnoIdnoFamily = function(userId, insuredID, policyNumber) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            idno: insuredID,
            plcno: policyNumber
        }
    }
    return body;
}

//新增家庭型關係
export const addContractFamilyRelationList = function(userId, familyRelationList, originalFamilyList) {
    let dataList = familyRelationList.map(data => {
        return {
            csid: data.csid,
            agidno: userId,
            cop_id: data.cop_id,
            cop_name: data.cop_name,
            cop_birthday: data.cop_birthday,
            cop_kind: data.cop_kind
        }
    })
    let delList = originalFamilyList.map(data => {
        return {
            csid: data.csid,
            agidno: userId,
            cop_id: data.cop_id
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            api_id: "addList",
            dataList: dataList,
            delList: delList
        }
    }
    return body
}

//查詢生日不同之被保人資訊
export const checkBirthDayDifferent = function(userId, CSLIST,isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            CSLIST: CSLIST
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body;
}

//檢核經管人才能自行輸入國壽保代
export const checkBnkCustomerAssign = function(userId, policyNoList) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            policyNoList: policyNoList
        }
    }
    return body;
}


//查詢生日不同之被保人資訊
export const checkCompanyColleague = function(userId, CSLIST) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            CSLIST: CSLIST
        }
    }
    return body;
}

//寫入生日不一致保單log紀錄
export const differBirthDayLog = function(userId, diffData, source) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            data: diffData,
            source: source
        }
    }
    return body;
}

//刪除自行輸入國泰產險保單
export const deleteSelfInputPropertyNumber = function(userId, plcno, pln) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            plcno: plcno,
            pln: pln
        }
    }
    return body
}

//查詢自行輸入國壽保單檢核訊息
export const getSelfCheckMsg = function(userId, insurances, isFromBank) {
    let dataList = insurances.map(data => {
        return {
            idno: data.insuredID,
            plcno: data.policyNumber
        }
    })
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId,
        },
        body: {
            agidno: userId,
            plcnoList: insurances.map((x) => x.policyNumber),
            dataList: dataList
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//刪除自行輸入國泰壽險保單
export const deleteSelfInputPolicyNumber = function(userId, plcno ,isFromBank) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agidno: userId,
            plcno: plcno
        }
    }
    if (isFromBank) {
        body.body.source = "BNK";
    }
    return body
}

//新/舊保健切換API
export const dotNetJavaConcat = function(userId, concatCode) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            CONCATCODE: concatCode
        }
    }
    return body
}

//取得指定刪除客戶
export const queryDeleteConsumer = function(userId, id, serNo) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            id: id,
            serNo: serNo
        }
    }
    return body
}

//查詢客戶by條件篩選
export const queryTodayDeleteList = function(userId, orderBy, order) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            agnt_id: userId,
            order_by: orderBy,
            order: order
        }
    }
    return body
}

// 取得新舊報表比對結果
export const getPDFcomparedResult = function(userId, agidno, csidno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: agidno,
            CSIDNO: csidno
        }
    };
    return body;
};

// 刪除新舊報表比對結果
export const deletePDFcomparedResult = function(userId, agidno, csidno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            AGIDNO: agidno,
            CSIDNO: csidno
        }
    };
    return body;
};

// 新增保單遮蔽資料
export const addPolicyCovered = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

// 查詢保單遮蔽資料
export const queryPolicyCovered = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

// 刪除保單遮蔽資料
export const deletePolicyCovered = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: { delete_id: userId, ...reqData }
    };
    return body;
};

// 查詢保單遮蔽刪除紀錄資料
export const queryPolicyCoveredDelete = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//-------------------------------------------------------------保單健檢-------------------------------------------------------------

//-------------------------------------------------------------商品設定-------------------------------------------------------------

//商品設定-查詢尚未發布商品列表
export const getUnreleasedProduct = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
        }
    };
    return body;
};

//商品設定-查詢已暫存商品列表
export const querySavedProduct = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢已暫存商品明細
export const getSavedProductDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢計畫別資料
export const querySchemeData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            schemeid: reqData
        }
    };
    return body;
};

//商品設定-新增計畫別資料
export const insertSchemeData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-編輯計畫別資料
export const updateSchemeData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-刪除計畫別資料
export const deleteSchemeData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-新增商品暫存資料
export const tempSaveInsuranceProduct = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-更新商品設定商品暫存資料
export const updateTempSavedInsuranceProduct = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-刪除商品設定商品暫存資料
export const deleteTempSavedInsuranceProduct = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢投資型利率變動型保障摘要
export const getInvestFormulaSummary = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢投資型利率變動型保單價值摘要
export const getInvestValueFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢投資型利率變動型身故及完全失能保障摘要
export const getDeathAndDisabilityFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢投資型利率變動型生存保險金保障摘要
export const getLivingFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-查詢投資型利率變動型滿期保險金保障摘要
export const getMaturityBenefitFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: reqData
        }
    };
    return body;
};

//商品設定-新增投資型利率變動型保障公式
export const addInvestFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-刪除所有投資型利率變動型保障公式
export const deleteAllInvestFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-刪除保單價值保障公式
export const deleteInvestFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-編輯投資型利率變動型保障公式
export const updateInvestFormula = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-更新投資型利率變動型保障公式順序
export const updateInvestFormulaPriority = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-資料庫匯率列表
export const getExchangeRate = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-查詢公司資料
export const getCompanyData = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-新增公司資料
export const insertCompanyData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            COMPNM: reqData.companyName,
            COMPSNM: reqData.companyShortName
        }
    };
    return body;
};

//商品設定-編輯公司資料
export const updateCompanyData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            COMPANYID: reqData.companyUUID,
            COMPID: reqData.companyId,
            COMPNM: reqData.companyName,
            COMPSNM: reqData.companyShortName
        }
    };
    return body;
};

//商品設定-刪除公司資料
export const deleteCompanyData = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            COMPANYID: reqData.companyUUID
        }
    };
    return body;
};

//商品設定-查詢年期資料
export const getYearPeriod = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-新增年期資料
export const insertYearPeriod = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢保險給付歸類
export const queryCoverageCategoryMain = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-編輯保險給付歸類
export const updateCoverageCategoryMain = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            coveragecategoryid: reqData.categoryId,
            name: reqData.categoryName
        }
    };
    return body;
};

//商品設定-刪除保險給付歸類
export const deleteCoverageCategoryMain = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            coveragecategoryid: reqData.categoryId
        }
    };
    return body;
};

//商品設定-新增保險給付歸類
export const newCoverageCategoryMain = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            name: reqData
        }
    };
    return body;
};

//商品設定-查詢所有報表種類
export const getAllReportType = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-以關鍵字查詢商品
export const queryProductByKeyWord = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            companyid: reqData.companyId,
            producttype: reqData.productType,
            contracttype: reqData.contractType,
            keyWord: reqData.keyWord
        }
    };
    return body;
};

//商品設定-以單一備註查詢商品清單
export const queryProductListByStateId = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            state_id: reqData
        }
    };
    return body;
};

//商品設定-新增報表註解
export const insertReportNoteDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-更新報表註解
export const updateReportNoteDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢備註歷史清單
export const getReportNoteRecord = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report_type: reqData
        }
    };
    return body;
};

//商品設定-查詢報表備註內容
export const getReportNoteDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            state_id: reqData
        }
    };
    return body;
};

//商品設定-停用報表註解
export const disableReportNote = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            note_id: reqData
        }
    };
    return body;
};

//商品設定-刪除報表註解
export const deleteReportNote = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            note_id: reqData
        }
    };
    return body;
};

//商品設定-查詢保障項目列表
export const queryCoverageCategory = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            parent: reqData
        }
    };
    return body;
};

//商品設定-查詢保障項目
export const getCoverageItemDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            coveragecategoryid: reqData.coveragecategoryid,
        }
    };
    return body;
};

//商品設定-編輯保障項目
export const updateCoverageItemDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            parent: reqData.itemKind,
            parentname: reqData.itemKindName,
            name: reqData.itemName,
            methodname: reqData.itemMethodName,
            coveragecategoryid: reqData.coverageCategoryId,
            sequencenumber: reqData.sequenceNumber,
        }
    };
    return body;
};

//商品設定-新增保障項目
export const insertCoverageItemDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            parent: reqData.itemKind,
            parentname: reqData.itemKindName,
            name: reqData.itemName,
            methodname: reqData.itemMethodName,
        }
    };
    return body;
};

//商品設定-刪除保障項目
export const deleteCoverageItemDetail = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            coveragecategoryid: reqData.coveragecategoryid,
            name: reqData.covergename,
            parentname: reqData.cotegory,
            sequencenumber: reqData.seq,
        }
    };
    return body;
};

//商品設定-查詢保障項目對應商品
export const queryCoverage = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            coveragecategoryid: reqData,
        }
    };
    return body;
};

//設定註解-取得保障分類與項目
export const getCoverageItems = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
        }
    };
    return body;
};

//設定註解-取得保障備註
export const getCoverageNotes = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reqData: reqData
        }
    };
    return body;
};

//設定註解-新增保障備註
export const addCoverageNote = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reqData: reqData
        }
    };
    return body;
};

//設定註解-刪除保障備註
export const deleteCoverageNotes = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reqData: reqData
        }
    };
    return body;
};

//設定註解-刪除全部保障備註
export const deleteAllCoverageNote = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            reqData: reqData
        }
    };
    return body;
};

//保障摘要-取得保障摘要
export const getCoverageSummary = function(reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: {
            reqData: reqData
        }
    };
    return body;
};

//醫療限額-初始化
export const initMedicalExpenseLimit = function() {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: {
        }
    };
    return body;
};

//商品設定-試算公式
export const calculateCoverage = function(reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: store.state.userInfo.id
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢商品是否可刪除
export const getIsProductDeletable = function(userId, productId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            productid: productId,
        }
    };
    return body;
};

//-------------------------------------------------------------商品設定-------------------------------------------------------------

//查詢離退人員(2023/13工後入職者)對應增員者名單
export const getResignIntrList = function(userId, cedvno3) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            cedvno3: cedvno3,
        }
    };
    return body;
}

//新增/更新離退人員(2023/13工後入職者)對應增員者解鎖檔
export const doResignUnlock = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: reqData,
        }
    };
    return body;
}

//查詢離退人員對應增員者是否解鎖
export const doQueryResignUnlock = function(userId, resign_id, intr_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            conditions: {
                resign_id: resign_id,
                intr_id: intr_id
            },
        }
    };
    return body;
}

//查詢離退人員主管未覆核資料清單
export const doQueryResignList = function(userId, cedvno3, type, c_id) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            cedvno3: cedvno3,
            type: type,
            c_id: c_id
        }
    };
    return body;
}